// i18n namespace `recognition` (en) — REQ-099 / REQ-102 / REQ-103.
const recognition = {
  // Armazon propio del modulo (menu lateral y cabecera): el portal no comparte estos textos.
  shell: {
    backToPortal: 'Back to portal',
    collapseMenu: 'Collapse menu',
    expandMenu: 'Expand menu',
    fundamentals: 'Fundamentals',
  },
  moduleTitle: 'Recognition Program',
  nav: {
    recognize: 'Recognize',
    shine: 'Shine Together',
    profile: 'My profile',
    admin: 'Admin',
    team: 'Team',
    dashboard: 'Dashboard',
    innovation: 'LATAM Innovation',
  },
  // F8 (paridad demo, H-96/H-97) — "More" tab and frontline mobile tab bar menu.
  frontlineMore: {
    tab: 'More',
    title: 'More options',
    documents: 'Documents',
    language: 'Language',
    selectLanguage: 'Select language',
  },
  common: {
    loading: 'Loading…',
    error: 'The information could not be loaded.',
    retry: 'Retry',
    empty: 'Nothing to show yet.',
    notConfigured: 'The recognition service is not configured.',
    forbidden: 'You do not have permission to view this section.',
    close: 'Close',
    remove: 'Remove',
    cancel: 'Cancel',
    insertEmoji: 'Insert emoji',
    actions: 'Actions',
  },
  recognize: {
    title: 'Recognize a colleague',
    subtitle: 'Thank a behavior aligned with our Fundamentals.',
    feedTitle: 'Recent recognitions',
    feedEmpty: 'No recognitions yet. Be the first to recognize someone!',
    newCta: 'New recognition',
    form: {
      messagePlaceholder: 'Write your recognition message…',
      anonymous: 'Send anonymously',
      submit: 'Send recognition',
    },
  },
  wall: {
    title: 'Recognition wall',
    count: '{{count}} recognitions',
    empty: 'No recognitions to show yet.',
    prev: 'Previous',
    next: 'Next',
    pageOf: 'Page {{page}} of {{total}}',
    for: 'for',
    anonymous: 'Anonymous',
    senderHidden: 'Identity not shown',
    points_one: '+{{count}} point',
    points_other: '+{{count}} points',
    pointsTitle: 'Points this recognition is worth',
    fundamentalsRecognized: 'Fundamentals recognized',
    fundIconTooltipAria: 'View all Fundamentals for this recognition',
    behaviorsRecognized: 'Behaviors recognized',
    habitsRecognized: 'Daily habits recognized',
    detailUnavailable: 'The full detail could not be loaded.',
    reportCount: 'Reported {{count}} time(s) — under review',
    receivedIn: 'Received in:',
    antiSpoilerBlurredHint: 'Wait for the Brillamos Juntos awards event to see your nominations.',
  },
  reactions: {
    addLabel: 'React',
    countLabel: '{{count}} reactions',
    modalTitle: 'Reactions',
    error: 'Could not save your reaction. Please try again.',
    whoReacted: 'Reacted',
    whoLoading: 'Loading…',
    whoEmpty: 'No one has reacted yet.',
    whoError: 'Could not load the list.',
  },
  origin: {
    diario: 'Daily',
    brillamos: 'Shine',
    personalizada: 'Campaign',
    csv: 'Bulk upload',
    delegado: 'Delegated',
    sistema: 'System',
  },
  panel: {
    title: 'Recognize your colleagues',
    recipientsLabel: 'People',
    recipientsPlaceholder: 'Search by name…',
    searchError: 'People could not be searched',
    fundamentalLabel: 'Fundamental (max {{max}})',
    fundamentalLabelUnbounded: 'Fundamental',
    maxFundamentalsHint: 'You can select up to {{max}} Fundamental(s) only.',
    behaviorsLabel: 'Behaviors',
    habitsLabel: 'Daily habits',
    habitRequiredHint: 'Select at least one daily habit before you can send.',
    summaryLabel: 'Summary',
    edit: 'Edit',
    messageLabel: 'Your message',
    messagePlaceholder: 'Why do you recognize this person?',
    anonymous: 'Send anonymously',
    sendToBrillamos: 'Also send to Brillamos',
    charCount: '{{count}} characters',
    charsAvailableHint: 'You are close to the limit. {{remaining}} characters left out of {{max}}.',
    charsLimitReachedHint: 'You have reached the {{max}}-character limit. Shorten part of your message to keep writing.',
    charsLimitSentenceNote: 'The sentence you built on the post-it also counts toward the limit.',
    errMessageTooLong: 'Your message is longer than the {{max}}-character limit. Shorten part of it and send it again.',
    errRecipientRequired: 'Choose the person you want to recognize before sending.',
    errFundamentalRequired: 'Choose at least one Fundamental before sending.',
    errSessionUnknown: 'We could not identify your session. Close the app, sign in again and try once more.',
    send: 'Send',
    sending: 'Sending…',
    sentTitle: 'Recognition sent!',
    sentSubtitle: 'Visible to the team and leader.',
    sendErrorGeneric: 'The recognition could not be sent. Please try again.',
    legalHint: 'You must accept the current legal terms before recognizing.',
    sendingDisabledHint: 'Sending recognitions is temporarily disabled.',
    scheduleRestrictedHint: 'Sending is outside the schedule window enabled for your location right now.',
    weeklyLimitHint: 'There is a cap of {{count}} recognitions per week for your location.',
    missingRecipientsHint: 'Select at least one person to recognize.',
    missingFundamentalHint: 'Select at least one Fundamental.',
    messageMinCharsHint: 'Write at least {{count}} characters in your message.',
    missingBehaviorForHabitHint: 'Choose a behavior to see the available daily habits.',
    noHabitsAvailableHint: 'This Fundamental has no daily habits configured; choose a different one.',
    groupTag: 'Team',
    delegateTitle: 'Sending mode',
    modeSelfTab: 'As myself',
    modeOnBehalfTab: 'On behalf of someone else',
    delegateLabel: 'On behalf of',
    delegateSubtitle: 'You can send recognitions on behalf of frontline team members.',
    delegatePlaceholder: 'Search team member…',
    onBehalfActiveBanner: 'You are recognizing on behalf of {{name}}.',
  },
  profile: {
    title: 'My recognition profile',
    subtitle: 'Your recognition activity and streak.',
    received: 'Received',
    sent: 'Sent',
    streak: 'Streak',
    empty: 'You have no recognition activity yet.',
    weeksStreak: 'Streak weeks',
    monthsStreak: 'Months of streak',
    record: 'Record',
    totalSent: 'Sent',
  },
  catalog: {
    title: 'Fundamentals',
    empty: 'The Fundamentals catalog is empty.',
  },
  notifications: {
    title: 'Notifications',
    close: 'Close notifications',
    placeholder: 'The notifications inbox will be available soon.',
    unread: '{{count}} unread',
    markAllRead: 'Mark all as read',
    markRead: 'Mark as read',
    readState: 'Read state',
    inviteToRecognize: 'Recognize someone',
    markUnread: 'Mark as unread',
    loadMore: 'See earlier notifications',
    recognitionUnavailable: 'This recognition is no longer available.',
    unsavedTitle: 'You have unsaved changes',
    unsavedDesc: "If you leave now, you'll lose what you're writing.",
    unsavedConfirm: 'Leave without saving',
    unsavedCancel: 'Stay here',
    campaignInactive: 'The campaign for this recognition has ended, so it can no longer be opened.',
    campaignUnavailable: 'This campaign has ended, so it can no longer be opened.',
    unavailable: 'The inbox is not available right now.',
    empty: 'You have no notifications.',
  },
  // ── WP-12/WP-13 (D4) — Shine+Nominate, Library, Profile, Wrapped ──
  home: {
    sent: 'Sent', received: 'Received', recognizeCta: 'Recognize now', recent: 'Recent Recognitions',
    active: 'Active campaign',
    ended: 'Campaign ended',
    daysLeft: '{{count}} days remaining',
    heroLogoAlt: 'Shine Together',
    nominateNow: 'Nominate now',
    // Demo parity (D1/D2) — /app/reconocer hero, mirrored from the demo's HomePage.tsx.
    titleLine1: 'Nominate someone who',
    titleVive: 'lives the',
    subtitle: 'Recognize a colleague who inspires others by living our Fundamentals.',
    cta: '✨ Recognize someone',
    // Paridad demo — estados vacios de los dos muros de la home (HomePage.tsx : 501 / 535).
    emptySent: "You haven't recognized anyone yet!",
    emptyReceived: 'Keep living the Fundamentals and you will be recognized soon!',
  },
  streak: {
    title: 'Your recognition streak',
    subtitle: 'Recognize every week and keep shining!',
    subtitleMonthly: 'Recognize every month and keep shining!',
    weeks: 'wks',
    months: 'mo',
    month: 'mo',
    monthsMany: 'mo',
    record: 'Record',
    total: 'Nominations',
    activeDays: '{{count}} active days this week',
    currentLevel: 'CURRENT LEVEL',
    atRisk: 'Your streak is at risk this week',
    atRiskMonthly: 'Your streak is at risk this month',
    // PHASE 7 (demo parity, H-91) — unified .streak-* family.
    current: 'Current streak',
    thisWeek: 'This week',
    days: 'days',
    today: 'Today!',
    nudgeDone: 'You already shone today! Keep it up 🌟',
    nudgeTodo: 'Recognize today and keep your streak! 🚀',
    periodProgress: '{{sent}} of {{min}} this week',
    periodProgressDone: 'Weekly goal reached! ({{sent}} of {{min}})',
    periodProgressMonthly: '{{sent}} of {{min}} this month',
    periodProgressDoneMonthly: 'Monthly goal reached! ({{sent}} of {{min}})',
    provisionalNote: 'Includes this week · confirmed at close',
    provisionalNoteMonthly: 'Includes this month · confirmed at close',
    badgeProvisional: 'AT CLOSE',
    badgeProvisionalTooltip: "You already met this period's minimum: the badge is showing now, and it's confirmed once the period closes.",
    badgesTitle: 'Badges',
    celebration: {
      title: 'Badge unlocked!',
      message: 'Keep it up, your consistency shows!',
      cta: 'Awesome!',
    },
    badgeWeek: '{{count}} week',
    badgeWeeks: '{{count}} weeks',
    badgeWeeksMany: '{{count}} weeks',
    badgeMonth: '{{count}} month',
    badgeMonths: '{{count}} months',
    badgeMonthsMany: '{{count}} months',
    note: '* The streak is calculated from sent recognitions',
    day: { mon: 'M', tue: 'T', wed: 'W', thu: 'T', fri: 'F', sat: 'S', sun: 'S' },
  },
  // 2026-08-10 — only `crossOu` is still used (by NominarView). The rest belonged to the
  // "Activity feed" of Brillamos Juntos (`BrillamosFeed`, deleted from the tree per client request).
  feed: {
    crossOu: 'Cross-OU',
  },
  docs: {
    allLanguages: "All languages",
    title: 'Campaign Documents',
    download: 'Download',
    loadError: "Couldn't load the document.",
    cat: {
      howto: 'How to Nominate',
      awards: 'Awards',
      legal: 'Legal Rules',
      privacy: 'Privacy Policy',
      cookies: 'Cookie Policy',
      notice: 'Legal Notice',
    },
  },
  library: {
    title: 'The Fundamentals',
    subtitle: 'The foundation of how we work, collaborate and grow at Sigma.',
    watchVideo: 'Watch video',
    behaviorsCount: '{{count}} Attitudes and Behaviors',
    dailyHabits: 'Daily Habits',
    micrositeSpace: 'Cultural microsite space',
  },
  nominate: {
    back: 'Shine Together',
    thanksTo: 'Thanks to {{name}} for',
    demonstrating: 'demonstrating {{fundamental}}',
    defaultMessage: 'Recognition sent',
    sentTitle: 'Nomination sent!',
    sentSubtitle: 'Thank you for making {{name}} shine.',
    redirecting: 'Returning to the campaign…',
    yourRecognition: 'Your recognition',
    thanksWord: 'Thanks to',
    slotWho: 'who?',
    forWord: 'for',
    slotWhat: 'what did they do?',
    demonstratingWord: 'demonstrating',
    slotFund: 'which fundamental?',
    elements: '{{done}}/3 elements',
    eyebrow: 'Create Recognition',
    title: 'Complete the three fields',
    field1: 'Tag your colleague',
    searchPlaceholder: 'Colleague name…',
    noResults: 'We could not find anyone with that name.',
    field2: 'Which Fundamental?',
    field3: 'What did they do?',
    noActions: 'This Fundamental has no behaviors configured.',
    pickFundFirst: 'Pick a Fundamental first.',
    completeMessage: 'Complete your message',
    personalizeTitle: 'Personalize your message',
    personalizeSub: 'Add your voice. The rest is ready.',
    messagePlaceholder: 'Describe the specific moment you observed…',
    charCount: '{{count}} characters',
    idealRange: '30–80 ideal',
    nudgeText: 'Your message will have more impact if you add a line of your own.',
    addLine: 'Add a line',
    sendAnyway: 'Send anyway',
    send: 'Send Nomination',
  },
  wrapped: {
    readyTitle: 'Your Recap is ready', readySubtitle: 'Relive the moments that made your {{year}} shine.', open: 'View my Recap',
    // RF-130 — Slide TITLES come from the current Recap edition (captured by the admin in Admin ›
    // Recap), so this namespace only keeps product labels: fallback captions, states and the teaser.
    // The 14 title keys that used to live here lost their consumer when the overlay started reading
    // the configuration, and were removed (D-6 of the RF-130 plan).
    introHint: 'A look back at your year of recognizing.',
    topReceptor: 'Who you recognized most',
    topEmisor: 'Your #1 fan',
    topFundamentalHint: 'The one you celebrated most.',
    bottomFundamentalHint: 'The one you celebrated least. Your challenge for this year.',
    crossOuValue: '{{count}} cross-OU recognitions',
    messageFrom: 'From {{name}}',
    winnerYear: 'Year {{anio}}',
    winnerPosition: 'Place {{position}}',
    sinceMonth: 'Your recap covers from {{month}} onward.',
    streakValue: '{{count}} weeks',
    streakValueOne: '{{count}} week',
    streakValueMany: '{{count}} weeks',
    streakValueMonth: '{{count}} months',
    streakValueMonthOne: '{{count}} month',
    streakValueMonthMany: '{{count}} months',
    unavailable: 'Your Wrapped is not available yet.',
    // RF-130 fix F1 (H-06) — the backend sends a STABLE KEY (`GetRecognitionWrappedQueryHandler.cs`),
    // not text. `WrappedModal.tsx` resolves it against these three, with a whitelist: never `t(rawKey)`.
    generosityTag: {
      generoso: 'Generous',
      muyGeneroso: 'Very generous',
      superGeneroso: 'Super generous',
    },
  },
  prof: {
    myFolders: 'My recognitions received, filtered by fundamental',
    viewingTitle: "{{name}}'s profile",
    backToMine: 'My profile',
    myTeam: 'Team',
    searchColleague: 'Search a colleague…',
    campaignBannerSub: 'The campaign is active — enter Shine Together',
    ctaRecognize: 'Recognize someone',
    myWrapped: 'My Wrapped {{year}}',
    brillamosFolder: 'Shine Together',
    emptySent: 'You have not sent any recognitions yet.',
    emptyBrillamos: 'No Shine recognitions here yet.',
    folderEmpty: 'No recognitions in this folder yet.',
    recognizeName: 'Recognize {{name}}',
    // FASE 6 (paridad demo, H-75/H-77/H-78) — perfil `.rp2-*`.
    thisWeek: 'This week',
    weekdayInitials: 'M,T,W,T,F,S,S',
    badges: 'Badges · Shine Together',
    recap: 'Wrapped {{year}}',
    sigmaMsg: '"Thank you for living the Sigma culture"',
    sigmaFrom: 'Sigma · {{year}}',
    sigmaNote: 'No recognitions received in {{year}}. This recognition is a reminder of your value to the team.',
    sigmaNoteSent: 'No recognitions sent in {{year}}. This recognition is a reminder of your value to the team.',
  },
  time: {
    moment: 'Just now',
    hours: '{{n}}h ago',
    yesterday: 'Yesterday',
    days: '{{n}} days ago',
  },
  // ── WP-11 REQ-104 — Interactive post-it / Word Builder ──
  builder: {
    modeLabel: 'Recognition mode',
    modeClassic: 'Classic',
    modeInteractive: 'Interactive',
    previewLabel: 'Recognition preview',
    thanksWord: 'I recognize',
    forWord: 'for',
    demonstratingWord: 'demonstrating',
    slotWho: 'who?',
    slotWhat: 'what did they do?',
    slotFund: 'which fundamental?',
    stepOf: 'Step {{step}} of {{total}}',
    step1Title: 'Who are you recognizing?',
    step3Title: 'Which behavior or habit?',
    step4Title: 'Add your message',
    complementPlaceholder: 'Describe the specific moment you observed…',
    noActions: 'This Fundamental has no behaviors or habits configured.',
    back: 'Back',
    next: 'Next',
  },
  ri: {
    bankLabel: 'Word Bank',
    bankTitle: 'Choose your words',
    bankHint: 'Tap a word below to complete your post-it 👇',
    forWhom: 'For whom',
    searchPlaceholder: "Colleague's name…",
    catAccion: 'Fundamentals',
    catComportamiento: 'Behaviors',
    catHabito: 'Habits',
    catImpacto: 'Impact',
    msgLabel: 'Your message',
    msgTitle: 'Build your recognition',
    words: 'items',
    clear: 'Clear',
    clickToRemove: 'Click to remove',
    clickHint: 'Click a word from the bank',
    pickFundFirst: '👆 Pick a Fundamental to see its behaviors',
    pickBehaviorFirst: '👆 Pick a behavior to see its habits',
    noHabitsForFund: '👆 This Fundamental has no habits configured',
    howLabel: 'How does it work?',
    howTitle: 'Three simple steps',
    step1: '<strong>Hover</strong> over a word and the target slot will light up.',
    step2: '<strong>Click</strong> the word to place it in the message.',
    step3: '<strong>Click the slot</strong> in the post-it to remove a placed word.',
    quote: 'Recognizing means naming the invisible. When we tell someone what we see in them, we build community.',
    cta: 'Complete your message',
    ctaDone: 'Complete your message →',
    popupTitle: 'Add your personal touch',
    popupChars: '30-80 characters ideal',
    nudgeMsg: 'Your message will have more impact with a personal line 💛',
    nudgeAdd: 'Add a line',
    nudgeSkip: 'Send as is',
    sent: 'Recognition sent!',
    sentIntro: 'Thanks to my',
    continueBtn: 'Continue →',
    seeRecognition: 'See my recognition →',
    clearReset: 'Clear and start over',
    wStep: 'Step {{step}} of {{total}}',
    wQPersona: 'Who are you recognizing?',
    wQFund: 'Which Fundamental?',
    wQBehavior: 'Which behavior?',
    wQHabit: 'Which habit?',
    wQImpact: 'What was the impact?',
    templateThanks: 'I recognize',
    templateForLiving: 'for living',
    templateWith: 'with',
    templateShowing: ', showing they',
    templateThat: '. That',
    slotPersona: 'person',
    slotAccion: 'fundamental',
    slotComportamiento: 'behavior',
    slotHabito: 'habit',
    slotImpacto: 'impact',
    impact1: 'inspires us',
    impact2: 'makes us grow',
    impact3: 'aligns us',
    impact4: 'drives the team',
    tooltipFundamental: 'A Fundamental is the value the person lived out.',
    tooltipComportamiento: 'The concrete behavior that showed that value.',
    tooltipHabito: 'The daily habit where that behavior shows up.',
    tooltipImpacto: 'The effect it had on the team.',
    guideStep1Title: 'Choose your words',
    guideStep1Text: 'Here you pick the Fundamental, behavior, habit, and impact you want to recognize.',
    guideStep2Title: 'Your post-it comes together',
    guideStep2Text: 'Each word you pick fills a spot in your recognition sentence.',
    guideStep3Title: 'Add your personal touch',
    guideStep3Text: 'This message is optional, but it makes your recognition more personal.',
    guideStep4Title: 'Send your recognition',
    guideStep4Text: 'Once it is complete, this button turns on and you can send it.',
    guideReopen: 'View the guide again',
    guideNext: 'Next',
    guideSkip: 'Skip',
    guideDone: 'Got it',
    progressLabel: '{{value}} of {{total}} steps completed',
  },
  // ── WP-11 REQ-106 — CSV bulk upload ──
  bulk: {
    or: 'or',
    open: 'Bulk upload',
    title: 'Bulk recognition upload',
    subtitle: 'Upload a CSV with several recognitions at once, review and fix before confirming.',
    stepInstructions: 'Instructions',
    stepUpload: 'Upload file',
    stepReview: 'Review',
    stepConfirm: 'Confirm',
    stepOf: 'Step {{step}} of {{total}}',
    next: 'Next',
    back: 'Back',
    instructionsIntro: 'Download the template, fill it in with one teammate per row, and upload it to validate and load in batch.',
    matchByIdentity: "Search for the person by their registered email or their payroll number — either one is enough. Don't know their email? The payroll number works just as well.",
    onePersonPerRowWarning: "Important: each row in the file is ONE single person. Don't put several emails or payroll numbers in the same cell — if you need to recognize multiple people, add one row per person.",
    // colRequired/colOptional: shared with adminBulkUsers/StepInstructions.tsx (Europe/US roster) —
    // this wizard no longer uses them (its fixed columns carry no required/optional tag). Don't
    // remove them as part of a cleanup here without checking that other consumer first.
    colRequired: 'Required',
    colOptional: 'Optional',
    colNameNombre: 'Name',
    colNameCorreoNomina: 'Email or Payroll ID',
    colNameFundamental: 'Fundamental',
    colReceptorEmailDesc: 'Email of who receives the recognition.',
    colMensajeDesc: 'Recognition message. May be required depending on your business unit.',
    colEmisorEmailDesc: 'Email of the sender. Empty = you.',
    colReceptorNominaDesc: "Payroll number of the recipient (AD, SuccessFactors, or the Europe roster). An alternative to email — it doesn't replace it, it's for people who don't have an email yet or haven't registered.",
    colEmisorNominaDesc: 'Payroll number of the sender. Empty = you.',
    markColumnsTitle: 'Plus one column for every Fundamental, Behavior, and Daily Habit',
    markColumnsIntro: 'After those fixed columns you\'ll see one column for each — mark the right one with an X (or any mark, like "yes"). No code to type.',
    markFundamentalHint: 'Mark one or more Fundamentals per row — up to the limit your organizational unit allows.',
    markBehaviorHint: 'Behavior is optional — you can mark several.',
    markHabitHint: 'Daily Habits are optional — you can mark several.',
    markColumnsOutro: 'The Mensaje column is the last one in the file, after all the mark columns.',
    downloadTemplate: 'Download template',
    templateError: 'Could not download the template.',
    catalogError: 'Could not load the Fundamentals catalog. Please try again — without the catalog, the file cannot be validated.',
    upload: 'Upload CSV',
    dragDropHint: 'Drag your CSV file here or click to select it.',
    invalidFileType: 'Only CSV files are accepted.',
    emptyFile: 'The file has no data rows.',
    parseError: 'Could not read the CSV file.',
    uploadError: 'Could not process the bulk upload.',
    validRows: '{{count}} valid rows',
    invalidRows: '{{count}} with errors',
    reviewHint: 'Fix the rows highlighted in red directly in the table; each change is re-validated.',
    colLine: '#',
    colReceptor: 'Recipient',
    colFundamental: 'Fundamental',
    colMensaje: 'Message',
    colReceptorNomina: 'Payroll #',
    colBehavior: 'Behavior',
    colHabits: 'Daily Habits',
    colStatus: 'Status',
    ok: 'Valid',
    expandRow: 'View details for row {{line}}',
    collapseRow: 'Hide details for row {{line}}',
    habitsCount_one: '{{count}} Daily Habit',
    habitsCount_other: '{{count}} Daily Habits',
    revalidating: 'Revalidating…',
    downloadErrors: 'Download errors (CSV)',
    confirmSummary: '{{count}} recognitions will be created. Rows with errors are skipped.',
    confirm: 'Load {{count}} valid',
    committed: '{{created}} recognitions were created. {{skipped}} rows were skipped.',
    duplicatesSkipped_one: '1 recognition was not sent: it had already been sent before with the same message.',
    duplicatesSkipped_other: '{{count}} recognitions were not sent: they had already been sent before with the same message.',
    notFoundTitle: 'Emails not found in the directory:',
    errors: {
      receptorRequired: "The recipient's email is required.",
      receptorNotFound: 'This email does not exist in the directory.',
      multiplePeopleNotSupported: 'This column must contain a single person (one email or one payroll number). To recognize multiple people, add one row per person.',
      fundamentalInvalid: "The Fundamental is required, or the message doesn't meet what's required in your business unit.",
      selfRecognition: "You can't recognize yourself.",
      blockedWord: "The message contains a word that isn't allowed.",
      weeklyCapExceeded: 'The sender reached their weekly recognition limit.',
      duplicateInFile: 'This row is repeated in the file.',
      behaviorInvalid: "The Behavior is not valid for this row's Fundamental.",
      habitInvalid: "One of the Daily Habits is not valid for this row's Fundamental.",
      campaignClosed: 'The campaign is not active.',
      notAllowedForCampaign: "This row is not allowed for this batch's campaign.",
      maxFundamentalsExceeded: "You can't select more Fundamentals for this recognition: the limit is set by the sender's organizational unit configuration.",
      generic: 'This row could not be validated.',
    },
  },
  // ── WP-11 REQ-107 — Post-it actions ──
  actions: {
    // RF-086 / RN-M06 — the reason catalog (`reportReasons`) was removed: the reason is free text.
    reportCharsLeft: '{{n}} characters left',
    edit: 'Edit',
    report: 'Report',
    delete: 'Delete',
    saveEdit: 'Save',
    editError: 'The recognition could not be edited.',
    editMinChars: 'The message must be at least {{min}} characters ({{count}}/{{min}}).',
    reportReason: 'Report reason',
    reportPlaceholder: 'Briefly describe the issue…',
    reportError: 'The report could not be sent.',
    reportSent: 'Report sent. Our team will review it.',
    sendReport: 'Send report',
    deleteConfirm: 'Are you sure you want to delete this recognition? This cannot be undone.',
    deleteError: 'The recognition could not be deleted.',
    confirmDelete: 'Yes, delete',
  },
  // ── WP-15 — Admin (REQ-126/127/128) ──
  admin: {
    // PLAN WP-U8-T5 — estas claves no existian en ningun locale.
    bulkUsers: {
      title: 'Bulk upload of the roster (Europe and US)',
      descLong: 'Creates and updates the Europe/US roster from a 24-column CSV, plus the region for the file (Europe or US), chosen when you upload it. It is incremental: anyone missing from the file is left untouched, and terminations are marked with the EMPLOYEE DELETED column. SuccessFactors syncs every other region automatically.',
      importHint: 'Download the template, fill it in, and upload it. Uploading first shows a preview that writes nothing. Dates use MM/dd/yyyy.',
      openWizard: 'Open bulk upload',
      wizardSubtitle: 'Upload the roster CSV, review the result, and confirm — nothing is written until the last step.',
      confirm: 'Confirm the upload',
      downloadErrors: 'Download errors (CSV)',
      received: 'Rows',
      created: 'Created',
      updated: 'Updated',
      deactivated: 'Deactivated',
      skipped: 'Skipped',
      disabled: 'The Europe/US bulk upload is disabled in the source settings.',
      previewNotice: 'Preview: nothing has been written yet. These are the counts the real upload will produce.',
      allOk: 'All rows were processed without errors.',
      importError: 'The file could not be processed.',
      importErrorTimeout: 'The server took too long to respond. The upload may have completed anyway on the server side — check the roster before retrying. Reference: {{correlationId}}',
      ignoredColumnsNotice: 'These columns from your file are not recognized and will be ignored: {{columns}}',
      confirmRecap: '{{total}} rows will be processed: {{created}} new, {{updated}} updated, {{deactivated}} deactivated.',
      committed: 'Upload complete: {{created}} new, {{updated}} updated, {{deactivated}} deactivated, {{skipped}} skipped.',
      paginationPage: 'Page {{page}} of {{total}}',
      errorColumn: 'Column',
      errorDetail: 'Error / omission detail',
      ouLabel: 'File region',
      ouPlaceholder: 'Select a region',
      ouEuropa: 'Europe',
      ouUsa: 'United States (USA)',
      ouCentral: 'Central',
      ouHint: 'Applies to every row in the file. It is no longer written per row in the CSV, to avoid typos or language mismatches.',
      ouRequired: 'Select the region before uploading the file.',
      col: {
        employeeDeleted: '1 deactivates the person; 0 or empty keeps them active.',
        localId: "Employee's payroll number. This is the key — without it the row cannot be processed.",
        firstName: 'First name.',
        lastName: 'Last name.',
        secondLastName: 'Second last name (optional).',
        completeName: "Full display name. If empty, it's built from the three fields above.",
        email: "Employee's email. Can be empty — the record stays in the roster until the person registers.",
        bu: 'Business unit.',
        siteId: 'Site/plant identifier.',
        site: 'Site/plant name.',
        orgDirectionId: 'Organizational Direction identifier.',
        orgDirection: 'Organizational Direction name.',
        funcDirectionId: 'Functional Direction identifier.',
        funcDirection: 'Functional Direction name.',
        departmentId: 'Department identifier.',
        department: 'Department name.',
        jobPosition: 'Job position.',
        manager: "Direct manager's name (informational only).",
        managerId: "Direct manager's payroll number. Used to link the hierarchy; the manager must already exist in the roster.",
        managerEmail: "Direct manager's email (informational only).",
        hireDate: 'Hire date, MM/dd/yyyy format.',
        birthDate: 'Date of birth, MM/dd/yyyy format.',
        notification: "YES or NO: whether the person receives notifications. Empty means 'not set', not NO.",
        country: "Person's country. Optional, but without it the person falls outside the scope of country administrators.",
      },
    },
    title: 'Administration',
    subtitle: 'Configure the Recognition Program.',
    denied: 'You do not have permission to access this section.',
    save: 'Save',
    saving: 'Saving…',
    saved: 'Changes saved',
    saveError: 'Changes could not be saved.',
    rowsPerPage: 'Rows per page',
    fundPanelTitle: 'Fundamentals Admin — Recognition',
    fundPanelSubtitle: 'Each module is independent. Turn it on or off according to your organisation needs.',
    pager: {
      showing: 'Showing {{range}} of {{total}}',
      perPage: '{{size}} per page',
      all: 'All',
      prev: 'Previous page',
      next: 'Next page',
      pageSize: 'Results per page',
    },
    nav: {
      roles: 'Configure roles and permissions',
      points: 'Points',
      moderation: 'Moderation',
      winners: 'Winners',
      campaigns: 'Campaigns',
      reports: 'Reporting',
      team: 'Team',
      dashboard: 'Dashboard',
      management: 'Management',
      notifications: 'Notifications',
      views: 'Views',
      docs: 'Documentation',
      recap: 'Recap',
    },
    roles: {
      title: 'Configure roles and permissions',
      desc: 'Manage administrators, their OU/country scope and their permission matrix.',
      searchEmail: 'Search by email…',
      empty: 'No administrators to show.',
      colAdmin: 'Administrator',
      colRole: 'Role',
      colScope: 'Scope',
      colStatus: 'Status',
      allScopes: 'All',
      active: 'Active',
      inactive: 'Inactive',
      edit: 'Edit',
      remove: 'Remove',
      removeConfirmTitle: 'Remove Brillamos administrator',
      removeConfirmMsg: 'Remove "{{name}}" as a Brillamos administrator? Their account remains a standard collaborator.',
      removeConfirm: 'Yes, remove',
      removeError: 'Could not remove the administrator role. Try again.',
      status: 'Status',
      permMatrix: 'Permission matrix',
      readOnlyConflict: '“Read only” cannot coexist with write permissions (RN-R03). Currently checked: {{permisos}}. Changing any box will resolve it; saving as-is will be rejected by the server.',
      addAdmin: 'Add administrator',
      addTitle: 'Add administrator',
      editTitle: 'Edit administrator — {{name}}',
      searchPersonLabel: 'Search employee',
      searchPersonPlaceholder: 'Employee name or email…',
      alreadyAdminNote: 'This person is already a Recognition administrator — edit their data below.',
      cannotEditGlobal: 'This person already has the General Admin role. That role is not managed from here.',
      selectRolePlaceholder: 'Select a role…',
      selectRoleFirst: 'Choose a role before saving.',
      saveForbidden: 'You do not have permission to make this change.',
      role: {
        AdminGlobal: 'General Admin',
        AdminBrillamos: 'Recognition Admin',
        AdminOUBrillamos: 'Recognition OU Admin',
      },
    },
    perm: {
      manageUsers: 'Manage users',
      manageRecognitions: 'Manage recognitions',
      manageNotifications: 'Manage notifications',
      manageDocuments: 'Manage documents',
      manageWinners: 'Manage winners',
      viewAnalytics: 'View analytics',
      viewReports: 'View reporting',
      exportData: 'Export data',
      configureViews: 'Configure views',
      bulkCsv: 'Bulk upload (CSV)',
      moderateContent: 'Moderate content',
      manageCampaigns: 'Manage campaigns',
      createCampaigns: 'Create and manage campaigns',
      readOnly: 'Read only',
      approveNominations: 'Confirm Winners',
      managePoints: 'Management',
      manageRoles: 'Configure roles and permissions',
      manageBlockedWords: 'Manage blocked words',
      managePointsConfig: 'Points',
      manageRecap: 'Edit annual Recap',
      delegateRecognition: 'Recognize on behalf of another',
      accessCatalogFundamentals: 'Fundamentals Catalog',
      accessCatalogOus: 'OUs Catalog',
    },
    points: {
      title: 'Points',
      desc: 'Configure points per criterion (0-9), mirrored for Staff/Frontline. Points are never visible to employees.',
      empty: 'No points criteria configured.',
      seg: { staff: 'Staff', frontline: 'Frontline' },
      segmentActive: 'Active',
      segmentActiveHint: 'If off, this table (Staff or Frontline) does not award points even if it has criteria configured.',
      lockedCampaign: 'Configuration is not editable once a campaign has started.',
      campaignActiveWarning: 'Points configuration cannot be edited while there is an active campaign in this organizational unit.',
      colCategory: 'Category',
      colCriterion: 'Criterion',
      colPoints: 'Points',
      colActive: 'Active',
      criterionActiveHint: 'If off, this criterion does not award points even when it is met.',
      colAccumulated: 'Accumulated total',
      accumulatedFooter: 'Nominations evaluated',
      resetAccumulated: 'Reset to 0',
      resetAccumulatedConfirmTitle: 'Reset accumulated total',
      resetAccumulatedConfirmMessage: 'The "Total accumulated" counter for this OU and segment will restart at 0. Recognition history is NOT deleted; it just stops counting from now on. This action cannot be undone.',
      resetAccumulatedSuccess: 'The accumulated total was reset to 0.',
      resetAccumulatedError: 'Could not reset the accumulated total.',
      accumulatedError: 'The nomination count could not be loaded.',
      accumulatedDisabledHint: 'With points switched off the engine does not evaluate, so the total stays at zero even if there are recognitions.',
      globalToggle: 'Points apply (global)',
      globalToggleHint: 'Turns the points system on or off for ALL organizational units, regardless of what each one has configured individually.',
      visibleToEmployees: 'Visible to employees',
      visibleToEmployeesHint: 'Shows the points of each recognition on the post-it for this OU. Never the running total of a person.',
      visibleUnknown: 'The switch state could not be read. Nothing changes until it is known.',
      visibleGdprBlocked: 'This OU is subject to GDPR: points are not shown even with the switch on.',
      globalOffHint: 'The global switch is off: no OU credits points, even if its table is active.',
      ouPicker: 'Organisational unit',
      ouPickPlaceholder: 'Select a unit…',
      pickOuFirst: 'Select an organisational unit to view and edit its points configuration.',
      accumulatedNoKey: 'This criterion has no canonical key, so it cannot be matched to the count.',
      globalOverriddenHint: 'This unit has its own exception, so here the switch is {{estado}} regardless of the global value.',
      globalOn: 'on',
      globalOff: 'off',

      globalUnknown: 'The global switch could not be read; its actual state is unknown.',
      noOuInProfile: 'Your profile has no organisational unit assigned, so there is no points configuration to show. Ask the global administrator.',
      exportReport: 'Download points report',
      exporting: 'Downloading…',
      exportError: 'The points report could not be generated. Try again.',
      exportEmpty: 'There are no points rows to export in this scope.',
      exportTruncated: 'The report was truncated at {{tope}} rows; narrow the scope to export everything.',
      exportNamesUnresolved: 'Some names could not be resolved; those rows show their identifier instead.',
      exportColPerson: 'Person',
      exportColOu: 'Organisational unit',
      exportColPoints: 'Points'
    },
    placeholder: {
      soon: 'This section will be available soon.',
      tracked: 'Tracked: {{req}}',
    },
    recognitions: {
      title: 'Recognitions',
      descLong: 'Manage the Fundamentals/Habits catalog: create, edit, enable/disable, link to a campaign and microsite.',
      tabActive: 'Fundamentals',
      tabTrash: 'Trash',
      tabHabits: 'Daily Habits',
      newHabit: 'New Daily Habit',
      habitSearchPlaceholder: 'Search habit…',
      habitsEmpty: 'There are no Daily Habits in the catalog.',
      colColor: 'Color',
      colNameEs: 'Name (ES)',
      colNameEn: 'Name (EN)',
      colParent: 'Parent Fundamental',
      colOuVisibility: 'Visibility by OU',
      ouInherited: 'Inherited from fundamental',
      habitStatusAll: 'All',
      habitStatusActive: 'Active',
      habitStatusInactive: 'Inactive',
      deleteHabitConfirm: 'Delete this Daily Habit from the catalog?',
      newHabitTitle: 'New Daily Habit',
      editHabitTitle: 'Edit Daily Habit',
      new: 'New Fundamental',
      searchPlaceholder: 'Search by code or name…',
      empty: 'The catalog is empty.',
      colCode: 'Code',
      colName: 'Name',
      colHabits: 'Habits',
      colBrillamos: 'Shine',
      colMicrosite: 'Microsite',
      colStatus: 'Status',
      inBrillamos: 'In Shine',
      notInBrillamos: 'Out',
      openMicrosite: 'Open',
      edit: 'Edit',
      deleteConfirm: 'Send this Fundamental to the trash?',
      trashEmpty: 'The trash is empty.',
      newTitle: 'New Fundamental',
      editTitle: 'Edit {{code}}',
      needAllLangs: 'Complete the name in all 7 languages.',
      fieldCode: 'Code',
      fieldOrder: 'Order',
      fieldName: 'Name',
      fieldShortName: 'Short name',
      fieldColor: 'Color',
      fieldMicrosite: 'Microsite URL',
      fieldCampaignScope: 'Linked campaign',
      campaignScopeHint: 'Campaign id (empty = global catalog)',
      fieldBrillamos: 'Participates in Shine Together',
      legacyCatalogWarning: 'This catalog is temporary: changes here are not yet reflected in what people see when recognizing others (P2-010).',
    },
    moderation: {
      desc: 'Blocked words and reports inbox.',
      title: 'Moderation',
      descLong: 'Reports inbox with routing data, blocked-words catalog and moderation toggles.',
      contentTitle: 'Content Moderation',
      wordsTitle: 'Blocked Words',
      wordsDesc: 'They are detected and blocked automatically when a recognition is sent.',
      wordsCounted: 'blocked words',
      manageWords: 'Manage',
      wordsManagerDesc: 'Add, edit or remove words by language. Works with 100+ words.',
      newWord: 'New word',
      region: 'Country/Region',
      regionGlobal: 'Global (all)',
      regionHint: 'The same language may have different words per country or region.',
      allRegions: 'All regions',
      searchWord: 'Search…',
      editWord: 'Edit word',
      word: 'Word',
      wordPlaceholder: 'e.g. inappropriate…',
      language: 'Language',
      addWord: 'Add',
      wordsEmpty: 'No words match the filter.',
      langOther: 'Other',
      // RF-082 — country→languages table that decides which catalog applies to each sender.
      countryLanguagesTitle: 'Countries and languages',
      countryLanguagesDesc: 'Define which languages are spoken in each country. A multilingual country (Belgium: nl and fr) applies the words of all its languages without capturing them twice. Countries in ISO-3166 (MX, ES, BE) and languages among the 7 the platform supports (es, en, pt, fr, de, nl, ro). To restrict a word to one country, use its Country/Region field.',
      countryLanguagesEmpty: 'The countries and languages table is empty.',
      regionsTitle: 'Regions',
      regionMembers: 'Countries in it',
      countryLanguagesInvalid: 'Check these codes before saving: {{codes}}. Countries use 2-letter ISO (MX) and the language must be one of the 7 the platform supports (es, en, pt, fr, de, nl, ro), with no country variant.',
      countryLanguagesUnreadable: 'The table could not be read, so it cannot be saved: saving replaces it whole and whatever is not shown would be lost.',
      country: 'Country',
      languages: 'Languages',
      languagesPlaceholder: 'nl, fr',
      addCountry: 'Add country',
      countryPlaceholder: 'MX',
      autoTitle: 'Auto-Moderation Settings',
      aiAutoBlock: 'Automatic AI blocking',
      aiAutoBlockHint: 'When on, every recognition message is checked by AI (Azure AI Content Safety) as it is sent and blocked if it is offensive.',
      helpAria: 'Help',
      aiHelp: 'Checks every message with AI (Azure AI Content Safety) as it is sent and detects toxicity in context (hate, threats, harassment). It is additive to the blocked-words catalog: both can be on at once. It requires "Moderation enabled (global)" to be on; with the global switch off, this layer does not apply.',
      globalHelp: 'Master switch for moderation. If off, NOTHING is moderated: neither AI blocking, nor the blocked-words catalog, nor are reports accepted. Turn it on for the other layers to work.',
      wordsHelp: 'Blocks exact words as messages are sent, regardless of context. It complements AI blocking (which catches toxicity in context). Both layers require "Moderation enabled (global)" to be on.',
      hideThreshold: 'Report threshold to hide',
      notifyReporter: 'Notify the reporter',
      aiPendingNote: 'With automatic AI blocking on, recognition messages are validated by Azure AI Content Safety as they are sent and rejected if they breach the conduct rules. It works alongside the blocked-words catalog.',
      hideThresholdHint: 'How many reports are needed to hide a recognition automatically. A value of 1 is the current rule: it is hidden on the first report.',
      notifyReporterHint: 'Saves the preference and sends it with the moderation event. The email to the reporter will be sent by NotificationService once that notification exists.',
      advanced: 'Advanced settings',
      globalEnabled: 'Moderation enabled (global)',
      reportEnabledGlobal: 'Report enabled by default',
      dailyReportLimit: 'Daily report limit',
      // RF-084 — per-node overrides of "allow reports", cascading Site -> BU -> OU -> global.
      overridesTitle: 'Reporting by unit (cascade)',
      overridesDesc: 'Exceptions to the global value. The most specific node wins: Site, then BU, then OU and its parent units. A unit with no exception inherits the one from its parent unit.',
      overridesNode: 'Unit, BU or Site',
      overridesNodePlaceholder: 'Pick an OU or type a BU/Site id',
      overridesAllow: 'Allowed',
      overridesBlock: 'Blocked',
      overridesEmpty: 'No exceptions: every unit uses the global value.',
      overridesDuplicate: 'An exception for “{{node}}” already exists. Identifiers are case-insensitive: edit or remove the existing one.',
      inboxTitle: 'Reports Inbox',
      inboxDesc: 'User reports. When hidden, the recognition disappears from the wall of whoever received it and from the sent recognitions of whoever issued it; it is also removed from the medal table and its points are cancelled.',
      searchName: 'Search by name…',
      filterAll: 'All',
      filterOu: 'OU: All',
      filterBu: 'BU: All',
      filterSite: 'Site: All',
      filterFrom: 'From',
      filterTo: 'To',
      filterType: 'Type: All',
      type: { fundamentales: 'Fundamentals', brillamos: 'Shine Together', diario: 'Daily Reco' },
      uiStatus: { pendiente: 'Pending', restaurado: 'Restored', eliminado: 'Deleted' },
      uiStatusPlural: { pendiente: 'Pending', restaurado: 'Restored', eliminado: 'Deleted' },
      status: { Publicado: 'Published', Pendiente: 'Pending', Resuelto: 'Resolved', Desestimado: 'Dismissed' },
      reportsEmpty: 'No reports match the filter.',
      colReportedBy: 'Reported by',
      colRecognitionFrom: 'Recognition from',
      colTo: 'To',
      colDetail: 'Detail',
      colReason: 'Reason',
      colDate: 'Date',
      colStatus: 'Status',
      colActions: 'Actions',
      // RF-090 — envelope button: escalates the case to the OU/country admin, no weekly wait.
      notifyAdmin: 'Notify admin',
      notifyAdminHint: 'Sends a notice right away to the administrator of this recognition unit, without waiting for the weekly digest.',
      notifyAdminConfirm: 'Send a notice to the administrator of {{name}}\'s unit? An email goes out immediately.',
      notifyAdminSent: 'Notice sent to the administrator.',
      notifyAdminError: 'The notice to the administrator could not be sent.',
      // RF-090 — recipient preview: the envelope button used to say "sent" even when nobody got it.
      notifyPreviewTitle: 'This notice will reach:',
      notifyPreviewLoading: 'Resolving recipients…',
      notifyPreviewEmpty: 'No recipient could be resolved.',
      notifyPreviewError: 'Could not check who the notice would reach.',
      notifyReason: {
        'sin-admins-en-la-ou': 'This unit has no administrator on record, and there are no global administrators to escalate the case to.',
        'escalado-a-globales': 'The unit has no administrator of its own, so the case is escalated to the global administrators.',
        'admin-sin-correo': 'The administrator has no usable email in the directory, so there is no way to write to them.',
        'directorio-no-responde': 'The user directory did not respond, so there is no way to tell who should be notified.',
        'suprimido-por-allowlist': 'The message would be dropped: this address is not on the notification service\u2019s list of allowed recipients.',
        'allowlist-desconocida': 'The allowed-recipient list could not be checked; the message may be dropped without a trace.',
        desconocido: 'The notice cannot be sent for a reason the service could not explain.',
      },
      deleteLabel: 'Delete',
      hideHint: 'Hides the recognition from the wall, removes it from the medal table and cancels its points.',
      restore: 'Restore',
      reopen: 'Reopen',
      reopenHint: 'Sends the case back to the queue as Pending and hides the recognition again.',
      viewDetail: 'View detail',
      detailTitle: 'Report detail',
      whoReported: 'Who reported',
      whoWasReported: 'Who was reported',
      reportedRecognition: 'Reported recognition',
      messageUnavailable: 'Text not available.',
      // RF-087 — case routing: email and OU are always rendered, with a marker when missing.
      dataUnavailable: 'Not available',
      detailLoading: 'Loading…',
      detailError: 'The up-to-date contact details could not be loaded; showing the ones stored when the report was filed.',
      chipOu: 'OU',
      chipBu: 'BU',
      chipSite: 'Site',
    },
    winners: {
      // Task 2.5 — card grid for Campaign Badges inside Winners (AdminCampaignBadgeGrid).
      campaignBadges: {
        title: 'Campaign Badges',
        permanenceNote: 'These badges are permanent: they are not turned on or off like streak badges; they stay tied to the campaign and year they were awarded for.',
        empty: 'No campaign badges yet.',
        edit: 'Edit',
        delete: 'Delete',
        deleteConfirm: 'Delete the campaign badge "{{name}}"? Its name in all 7 languages, icon, and year will be lost. This cannot be undone.',
        add: '+ Add badge',
        editTitle: 'Edit campaign badge',
        fieldTitle: 'Title',
        fieldYearSubtitle: 'Year / Subtitle',
        fieldYear: 'Award year',
        yearNone: 'No year',
        fieldYearHint: 'Checked when granting: a badge from one year cannot be given in a campaign from another. "No year" turns the check off.',
        fieldImage: 'Image',
        imageUploadHintNew: 'Save the badge first to be able to upload its image.',
        imageFormatInvalid: 'The image format is not valid. Use PNG, JPG, WEBP, or SVG.',
        previewTitle: 'Preview',
      },
      bulkTitle: 'Bulk confirmation',
      bulkSelected: '{{count}} selected',
      bulkConfirm: 'Confirm {{count}}',
      bulkConfirming: 'Confirming…',
      bulkClear: 'Clear selection',
      bulkSelectAll: 'Select all pending on this page',
      bulkSelectOne: 'Select {{name}}',
      bulkFailed: '{{count}} could not be confirmed. The rest were; retry with just those.',
      editTitle: 'Edit winner — {{nombre}}',
      actionError: 'The action could not be completed.',
      badExtension: 'Unsupported format. Accepted: {{ext}}',
      // No son «Área»/«Site»: el backend resuelve esas dos columnas con el PUESTO y el
      // DEPARTAMENTO de la ficha de la persona (ver AdminWinners.tsx).
      colPuesto: 'Job Title',
      colDepto: 'Department',
      colFundamental: 'Fundamental',
      colStatus: 'Status',
      colUser: 'User',
      colUserNomina: 'Payroll number: {{nomina}}',
      colYear: 'Year',
      colBadge: 'Badge',
      badgeNone: 'No badge',
      exportFiltered: 'Download the winners matching the current filters as Excel',
      exportEmpty: 'No winners to export with these filters',
      exporting: 'Exporting…',
      exportTruncated: 'The download was capped at 5000 rows. Narrow the filters to export the rest.',
      exportError: 'The download could not be completed. Try again.',
      confirmAction: 'Confirm as winner',
      confirmDelete1: 'Remove {{nombre}} from the winners list?',
      confirmDelete2: 'This cannot be undone and it is logged. Confirm?',
      deleteTitle: 'Remove winner',
      deleteConfirm: 'Remove',
      countryAll: 'Country: All',
      editAction: 'Edit',
      editClosed: 'Outside the editing period.',
      editWindowNote: 'You can edit a winner for up to 1 month after uploading it. The General Admin can edit any winner from the last 3 years.',
      exportNominations: 'Export nominations',
      exportWinners: 'Export winners',
      exportNominationsTruncated: 'The download was limited to 5000 rows. Pick a campaign with fewer nominations or try again in parts.',
      exportNominationsEmpty: 'There are no nominations to export for this campaign.',
      exportPending: 'The export is wired in the next work package.',
      filterCountry: 'Country',
      filterFundamental: 'Fundamental',
      filterYear: 'Year',
      filtersToggle: 'Filters',
      flowHint: 'Winners are uploaded from a file. The flow is: upload the template → it appears here → you confirm the final winner.',
      fundamentalAll: 'Fundamental: All',
      fundamentalNone: 'No fundamental',
      importErrorsTitle: 'Rejected rows',
      importSummary: '{{importados}} of {{total}} rows imported · {{rechazados}} rejected.',
      manageTitle: 'Winners management',
      moduleHint: 'Enable it to allow uploading winners and assigning badges.',
      moduleOffWarn: 'Winners module disabled. For now this setting is only saved: it does not change what users see yet.',
      moduleSaveError: 'Could not save the change to the Winners module. Please try again.',
      moduleTitle: 'Winners module',
      needsCsv: 'This is a binary Excel workbook and cannot be read. Open it and save it as CSV (UTF-8) before uploading.',
      noResults: 'No winners match the filter.',
      ouAll: 'OU: All',
      pagerInfo: 'Page {{page}} of {{paginas}} · {{total}} winners',
      searchByName: 'Search by name…',
      statusConfirmed: '✓ Confirmed',
      statusPending: '⏳ Pending',
      uploadFile: 'Upload Excel',
      uploadCampaign: 'Roster campaign',
      uploadMode: 'Roster edition',
      uploadModeCurrent: 'Current',
      uploadModeHistoric: 'Historic',
      uploadOpen: 'Upload roster',
      uploadOpenHint: 'Opens the wizard to upload the winners roster, current or historic.',
      uploadModalTitle: 'Upload winners roster',
      uploadModalToggleHint: 'Pick "Current" if the roster belongs to a campaign that is active on the site. Pick "Historic" to load past awards that are not documented as a campaign.',
      uploadBadge: 'Badge',
      uploadBadgeHint: 'Every row in the file will receive THIS badge. Pick it before uploading the file.',
      uploadBadgePick: 'Pick the badge…',
      uploadBadgeClarify: 'The badge is not a campaign: it is the image the person will see as their earned award (for example, a medal or a trophy).',
      pickBadgeFirst: 'Pick the badge the winners in this file are going to receive first.',
      uploadHistoricWarning: 'Historic data is saved directly, without linking to any campaign. Double-check name, email and badge before uploading.',
      helpOpen: 'Help uploading the roster',
      helpModalTitle: 'How do I upload the winners roster?',
      helpIntroVigente: 'Current: use it when the award belongs to a campaign that exists on the site and is active right now. You pick the campaign and the badge (the image shown as the earned award) and download the template: it only asks for the person\'s email or employee ID. Their name, year and OU/site are already known by the system — no need to type them.',
      helpIntroHistorico: 'Historic: use it when the award is from an old campaign that no longer exists on the site, or one you have no record of. You do NOT pick a campaign: instead you pick ONE badge (the image shown as the earned award, not a campaign name), which will be given to EVERY person in the file. Download the 2-column template (Name and Email or Employee ID), fill it in and upload it.',
      helpDirectorio: 'The email or employee ID has to exist in the company directory. If neither is found, that row is rejected and the rest of the file still loads. If the person doesn\'t have an email (for example, plant staff), write their employee ID in that same column — you don\'t need the email if you already entered the employee ID.',
      helpNoDownload: 'If you try to download a file and there is no data to show, nothing downloads: you get a message on screen instead.',
      downloadTemplateHint: 'Download a blank Excel with the right columns for this mode, in your language.',
      downloadTemplateCurrent: 'Download current template',
      downloadTemplateHistoric: 'Download historic template',
      uploadFileHint: 'Upload the filled-in Excel with the roster data.',
      importWizard: {
        subtitle: 'Upload the roster, review the result before confirming, and download the errors if something fails.',
        colNombreDesc: "Winner's name, exactly as it will be shown.",
        colNombreDescVigente: "Winner's name. You can leave it empty: if you don't type it, the name already on file for that person is used.",
        colEmailDesc: "The person's email OR employee ID — either one is enough; it identifies who receives the prize.",
        colFundamentalDesc: 'Recognized Fundamental (name in any language, or catalog code). Ignored if it matches none.',
        badgePreviewHint: 'This is how the badge looks — exactly what each winner in this file is going to receive.',
        dropHint: 'Drag your Excel or CSV file here, or click to choose it.',
        reviewHint: 'This is a VALIDATION only: nothing is saved yet. Review the summary and, if needed, go back to pick a corrected file.',
        previewPending: 'Validating file…',
        noErrors: 'No errors — all rows are valid.',
        fileLevelError: 'File/selection',
        confirmPending: 'Saving…',
      },
      filterEstado: 'Status',
      estadoAll: 'Status: All',
      uploadCampaignPick: 'Choose the campaign…',
      pickCampaignFirst: 'Choose the campaign this roster belongs to first.',
      exportNominationsCatalogError: 'Could not load the Fundamentals/Habits catalog: the export could come out incomplete. Please try again.',
      yearAll: 'Year: All',
      desc: 'Shine Together winners registry.',
      title: 'Winners',
      descLong: 'Winners by campaign/OU. Manual entry and CSV history import with per-row feedback.',
      filterCampaign: 'Campaign',
      campaignIdHint: 'Campaign id',
      filterOu: 'OU',
      ouHint: 'OU id',
      add: 'Add winner',
      addTitle: 'New winner',
      fieldCampaign: 'Campaign',
      fieldUser: 'User',
      fieldName: 'Name',
      fieldOuName: 'OU',
      fieldCountry: 'Country',
      fieldPosition: 'Position',
      save: 'Save',
      importTitle: 'CSV import',
      importHint: 'Download the template, fill it and upload it. Import is idempotent by campaign + user.',
      downloadTemplate: 'Download template',
      uploadCsv: 'Upload CSV',
      templateError: 'Could not download the template.',
      importError: 'Could not process the import.',
      deleteError: 'Could not remove this winner.',
      totalRows: 'Total rows',
      imported: 'Imported',
      rejected: 'Rejected',
      row: 'Row',
      reason: 'Reason',
      empty: 'No winners for the filters.',
      colPosition: 'Position',
      colName: 'Name',
      colOu: 'OU',
      colCountry: 'Country',
      colCrossed: 'Cross origin',
      colDate: 'Registered',
      // Task 16 — headers for the raw nominations export (i18n, no longer hardcoded Spanish).
      nominationsExport: {
        // The `nominee*` keys hold the person who SUBMITTED the nomination (the DTO's Nominee_*
        // block maps to Recognition.EmisorSnapshot). Whoever was nominated is the `candidate*`
        // block below — translating these as "nominee" left the export with two column groups
        // meaning the same thing and none naming the nominator.
        nomineeName: 'Nominator: Name',
        nomineeEmail: 'Nominator: Email',
        nomineeEmployeeId: 'Nominator: Payroll #',
        nomineeOu: 'Nominator: OU',
        nomineeBu: 'Nominator: BU',
        nomineeSite: 'Nominator: Site',
        nomineeDepartment: 'Nominator: Position',
        onBehalfOfName: 'On Behalf Of: Name',
        onBehalfOfEmail: 'On Behalf Of: Email',
        onBehalfOfEmployeeId: 'On Behalf Of: Payroll #',
        onBehalfOfOu: 'On Behalf Of: OU',
        onBehalfOfBu: 'On Behalf Of: BU',
        onBehalfOfSite: 'On Behalf Of: Site',
        onBehalfOfDepartment: 'On Behalf Of: Position',
        candidateName: 'Candidate: Name',
        candidateEmail: 'Candidate: Email',
        candidateEmployeeId: 'Candidate: Payroll #',
        candidateOu: 'Candidate: OU',
        candidateBu: 'Candidate: BU',
        candidateSite: 'Candidate: Site',
        candidateDepartment: 'Candidate: Position',
        date: 'Date',
        year: 'Year',
        month: 'Month',
        habitPrefix: 'Habit',
        comment: 'Comment',
        streakBadge: 'Streak Badge',
        fromDayToDay: 'From Day-to-Day',
        status: 'Status',
        type: 'Type',
        audienceNominee: 'Nominator Audience',
        audienceCandidate: 'Candidate Audience',
        points: 'Points',
        retiredHabitsGroup: 'Other / retired habits',
      },
    },
    campaigns: {
      desc: 'Recognition campaign wizard.',
      statusDivider: 'Campaign status',
      title: 'Campaigns',
      descLong: 'Campaign list and 5-step wizard: Info, Audience, Configuration, Documents and Publish.',
      filterAll: 'All',
      status: {
        Borrador: 'Draft', Activa: 'Active', Finalizada: 'Finished', PendienteAprobacion: 'Pending approval',
        // Bug UAT #114 — «Activa» significaba dos cosas: corriendo, o marcada activa
        // pero fuera de su ventana de fechas (el colaborador no la ve).
        ActivaVencida: 'Active · outside window',
        ActivaPorIniciar: 'Active · not started yet',
        ActivaVencidaHint: 'The campaign is still marked active, but its date range has ended: people in its scope do not see it.',
        ActivaPorIniciarHint: 'The campaign is active but its start date has not arrived yet.',
      },
      approvals: 'Approvals',
      new: 'New campaign',
      empty: 'No campaigns.',
      colName: 'Name',
      colType: 'Type',
      colStatus: 'Status',
      colScope: 'Scope',
      allScopes: 'All OUs',
      editBtn: 'Edit',
      duplicate: 'Duplicate',
      panic: 'Stop Campaign',
      deactivateConfirmTitle: 'Stop OU exception',
      deactivateConfirmMsg: 'Stop this OU exception now? It will immediately stop applying to its scope.',
      panicConfirm: 'Stop this campaign immediately?',
      type: { Fundamentales: 'Fundamentals', Brillamos: 'Shine', Personalizada: 'Custom' },
      wizardEditTitle: 'Edit campaign',
      wizardNewTitle: 'New campaign',
      wizardSub: 'Complete the 6 steps to create or edit the campaign.',
      backToList: 'Back to list',
      step: { info: 'Info', design: 'Design', audience: 'Audience', config: 'Configuration', documents: 'Documents', publish: 'Publish' },
      tabFundamentales: 'Fundamentals',
      tabBrillamos: 'Shine Together',
      tabPersonalizadas: 'Custom',
      fundActiveTitle: 'Always Active',
      fundRules: 'Send rules',
      fundActiveDesc: 'Fundamentals is the base of the recognition program. It cannot be turned off, only its rules configured.',
      fundConfigNote: 'Detailed send rules and limits are managed in the Management section.',
      globalPanic: 'Stop All Campaigns',
      globalPanicConfirm: 'Immediately end ALL active Shine Together campaigns? This action cannot be undone.',
      globalPanicDone: '{{count}} campaign(s) ended.',
      docCategoria: 'Category',
      docCatNone: 'No category',
      fieldType: 'Campaign type',
      fieldName: 'Name',
      fieldDescription: 'Description',
      fieldSlug: 'Landing slug',
      fieldScope: 'Scope (OUs)',
      fieldExclusions: 'Exclusions',
      fieldStart: 'Start date',
      fieldEnd: 'End date',
      fieldTimezone: 'Time zone',
      fieldStreakMinimum: 'Campaign streak minimum',
      streakMinimumInherit: 'Use the global one',
      streakMinimumHint: 'Sends this campaign requires to add streak in the period (1-20). Empty = the global minimum from Management applies.',
      streakMinimumLocked: 'The campaign already started: the streak minimum cannot change without re-qualifying the period in progress.',
      fieldRecognitionsLimitOwn: 'Campaign send limit',
      recognitionsLimitOwnInherit: 'Use the global value',
      recognitionsLimitNotApplicable: 'Not applicable (no send limit)',
      recognitionsLimitNotApplicableShort: 'No limit',
      fieldSameFundamentalLimit: 'Times same fundamental to the same person',
      sameFundamentalInherit: 'Use the global value',
      sameFundamentalNotApplicable: 'Not applicable (no limit)',
      sameFundamentalNotApplicableShort: 'No limit',
      recognitionsLimitOwnHint: 'Recognitions this campaign allows per period. Empty = the global Gestión limit applies. Editable at any time, even with the campaign already active.',
      fieldWrappedRelease: 'Wrapped release',
      wrappedReleaseOnFinish: 'When the campaign closes',
      wrappedReleaseHint: 'Day the Wrapped becomes visible for this campaign’s scope, in its own time zone. Empty = it is released when the campaign moves to Finished.',
      visibility: 'Visibility',
      visSender: 'Show sender',
      visFundamental: 'Show fundamental',
      visText: 'Show text',
      visHabit: 'Show habit',
      visSent: 'Sent counter',
      visReceived: 'Received counter',
      visAnonymous: 'Allow anonymous',
      visBulk: 'CSV bulk upload',
      visReactions: 'Reactions (👏❤️😊🎉👍)',
      visCampaignTag: 'Show campaign tag',
      visFromFundamentals: 'Allow sending from Fundamentals',
      visSendingDisabled: 'Disable recognition sending',
      anonymousOverrideLabel: 'Anonymous recognitions',
      anonymousOverrideInherit: 'Inherit from Gestión',
      anonymousOverrideAllow: 'Allow',
      anonymousOverrideDeny: 'Do not allow',
      anonymousOverrideHint: 'Applies ONLY to this campaign. Left as "Inherit from Gestión", this campaign uses the global setting.',
      points: 'Points',
      pointsLocked: 'Points are immutable: the campaign already started.',
      pointsHint: 'Europe only; the frontend never shows points.',
      applyPoints: 'Campaign grants points',
      brillamosRecurringDesc: 'Recurring Fundamentals-based nomination campaign.',
      paisScheduleTitle: 'Schedules and Dates by Country',
      paisScheduleIntro: 'Configure different schedules or dates per country. If unset, it inherits the global window.',
      paisCol: 'Country',
      paisOpen: 'Open time',
      paisClose: 'Close time',
      paisActive: 'Active',
      paisApplySchedule: 'Apply schedule',
      paisClearHours: 'Clear schedule',
      paisOverrideBadge: 'OU campaign',
      paisOverrideWins: 'Takes precedence over this row: {{alcance}}.',
      paisOverrideNoSend: 'Sending disabled',
      paisOverrideDates: 'Dates {{inicio}} → {{fin}}',
      paisOverrideHours: 'Hours {{inicio}}–{{fin}}',
      paisScheduleNoActive: 'There is no active Shine Together campaign: country schedules are set on the campaign currently running. Activate a campaign to capture them.',
      saveDraftFirst: 'Save the draft to manage its documents.',
      saveDraft: 'Save draft',
      saveDraftLater: 'The draft is saved once you finish the configuration. Use “Next” to move through the steps.',
      dates: 'Dates',
      publishRequirements: 'Requires a name in all 7 languages, at least one scope OU and start and end dates. Save is enabled once the configuration is complete.',
      valNameAllLangs: 'Enter the name in all 7 languages.',
      valScope: 'Select at least one organizational unit in the scope.',
      scopeConflict: "These units are already in an active campaign: {{campanas}}. Remove them from the scope or end that campaign.",
      valScopeConflict: "The scope conflicts with an active campaign: {{campanas}}.",
      scopeConflictPartial: "There are more active campaigns than could be reviewed: the conflict check may be incomplete.",
      scopeEmpty: "You have no organizational units in your scope to create campaigns. Ask a global administrator to assign you a scope.",
      outOfScopeHint: "This campaign includes organizational units outside your scope: only an administrator who covers all of them can edit it.",
      valScopeExcludesOwn: "You cannot exclude your own organizational unit from the scope.",
      valStart: 'Enter the campaign start date.',
      valEnd: 'Enter the campaign end date.',
      valTimezone: 'Select the campaign time zone.',
      valDateOrder: 'The end date must be later than the start date.',
      designMenu: 'Icon and title in the side menu',
      designMenuHint: 'This is how the campaign will appear in the platform sidebar for users.',
      designIcon: 'Icon',
      designMenuTitle: 'Menu title',
      designMenuTitlePh: 'e.g. LATAM Innovation',
      designSections: 'Landing sections',
      designSectionsHint: 'The banner and the nomination form are always present. Enable the optional sections.',
      designShowStreak: 'Recognition streak',
      designShowRecent: 'Recent recognitions',
      designBrillamosLocked: 'The Shine Together identity is immutable: its design cannot be edited.',
      approvalSent: 'Approval request sent.',
      submitApproval: 'Submit for approval',
      submitApprovalConfirmTitle: 'Submit for approval',
      submitApprovalConfirmMsg: 'Submit this campaign for approval? The Admin General will need to review it before it goes live.',
      prev: 'Previous',
      next: 'Next',
      docLang: 'Language',
      docUrl: 'Document URL',
      docTitle: 'Title',
      addDoc: 'Add document',
      docCategoryRequired: 'Select a category before adding the document.',
      docTitleRequired: 'Complete the title in all 7 languages before adding the document.',
      docsEmpty: 'No documents.',
      docsFallbackNote: 'If no documents are uploaded here, this campaign shows the ones from the Documentation section of the administration.',
      approvalsTitle: 'Pending approvals',
      approvalsSub: 'Campaigns awaiting your approval (AdminGlobal).',
      approvalsEmpty: 'No pending approvals.',
      colCampaign: 'Campaign',
      requestedBy: 'Requested by',
      approve: 'Approve',
      approveConfirmTitle: 'Approve campaign',
      approveConfirmMsg: 'Approve this campaign? It will become active and visible to its scope.',
      reject: 'Reject',
      rejectReason: 'Reason for rejection (required)',
      rejectConfirm: 'Confirm rejection',
      viewDetail: 'View detail',
      bannerDesign: 'Banner design',
      bannerScopeLabel: "This banner applies only to this campaign; if left unset, it inherits the program's global banner.",
      bannerDesignHint: 'Switch language above to edit the title, subtitle and logo for that language — the preview updates live.',
      bannerTitle1: 'Title (line 1)',
      bannerTitle2: 'Title (line 2)',
      bannerSubtitle: 'Subtitle',
      bannerLogoNote: 'The logo image (PNG per language) upload is coming soon.',
      bannerLogo: 'Logo (image for this language)',
      bannerLogoUpload: 'Upload PNG',
      bannerLogoReset: 'Reset to default',
      bannerLogoHint: 'Recommended: transparent PNG ~4:3. The Fundamentals logo is shown by default.',
      bannerLogoErrPng: 'The logo must be a PNG.',
      bannerLogoErrSize: 'The PNG must not exceed 500 KB.',
      bannerPreview: 'Preview',
      bannerPreviewEmpty: 'Banner title',
      bannerCta: 'Recognize someone',
      brillamosBannerTitle: 'Shine Together banner',
      brillamosBannerHint: 'Customize the subtitle and logo of the Shine Together hero per language. The preview updates live.',
      brillamosBannerLogoHint: 'Recommended: transparent PNG. The Shine logo is shown by default.',
      entryPoints: 'Recognition mode (entry points)',
      entry: { A: 'Entry A — Classic form', B: 'Entry B — Interactive post-it', both: 'Both visible (A/B test)' },
      commentRequired: 'Comment required',
      vista: 'View:',
      vistaGlobal: 'Global Admin',
      vistaOu: 'OU Admin / Ambassador',
      rulesTitle: 'Send Rules',
      brillamosRulesIntro: 'These rules apply only to Shine Together. A blank field inherits the global value from Management.',
      ruleMultiPersona: 'Multi-person',
      ruleMultiFundamental: 'Multi-fundamental',
      ruleBulkCsv: 'Bulk CSV upload',
      ruleReactions: 'Wall reactions',
      ruleSendingDisabled: 'Disable sending',
      ruleAnonymousEnabled: 'Allow anonymous recognitions',
      anonymousGestionHint: 'Applies to everything (Fundamentals, Brillamos and custom campaigns) unless a campaign sets its own value in the wizard\'s Configuration step. Does not affect automatic GDPR anonymization in Europe.',
      ruleMinChars: 'Min. characters',
      moderationTitle: 'Moderation',
      modPostEdit: 'Post-submit editing',
      moderationNote: 'The Report button and Word filter are managed in the Moderation section.',
      resetToGlobal: 'Reset (inherit from global)',
      streakTitle: 'Streak Settings (Fundamentals)',
      streakActive: 'Streak active',
      streakSentNote: 'The streak is calculated by recognitions SENT.',
      streakInProfile: 'Show streak in profile',
      badgesActive: 'Badges active',
      streakPeriod: 'Period',
      periodWeekly: 'Weekly',
      periodMonthly: 'Monthly',
      periodDaily: 'Daily',
      limitsTitle: 'Caps (Limit Management)',
      limitsActive: 'Caps active',
      limitName: 'Name',
      limitDescription: 'Description',
      limitRecognitionsDesc: 'Maximum recognitions',
      limitFundamentalsDesc: 'Max selectable per submission',
      limitValue: 'Limit',
      limitFrequency: 'Frequency',
      limitActiveCol: 'Active',
      limitRecognitions: 'Recognitions per period',
      limitFundamentals: 'Fundamentals per reco',
      perSubmission: 'Per submission',
      readonlyTitle: 'General Configuration — Fundamentals (applied by default)',
      readonlyBadge: 'Read only',
      readonlyNote: 'If you want to add a exception by OU, it will go through Global Admin approval.',
      colDate: 'Date',
      exc: {
        title: 'Exceptions by OU',
        intro: 'Point exceptions to the base configuration for a specific OU/BU/Site scope. Each one goes through Global Admin approval.',
        new: 'New exception by OU',
        colException: 'Exception',
        colScope: 'OU / BU / Site',
        colState: 'Exception status',
        fullOu: 'Whole OU',
        sites: '{{count}} sites',
        scopePopTitle: 'Sites in scope',
        stateActive: 'Active',
        stateInactive: 'Inactive',
        toggleHint: 'Only an approved exception can be turned on or off.',
        edit: 'Edit',
        delete: 'Delete',
        empty: 'No exceptions by OU yet.',
        deleteTitle: 'Delete exception',
        deleteMsg: 'This exception by OU will be permanently removed. This action cannot be undone.',
        deleteConfirm: 'Delete',
        summaryTope: 'Cap: {{max}} recos / {{freq}}',
        summaryDisable: 'Disable sending',
        disableTitle: 'Disable sending (override)',
        disableNote: 'Temporarily blocks sending recognitions for the selected scope, without deactivating the program. Requires Global Admin approval.',
        summarySchedule: 'Restricted schedule',
        summaryVisibility: 'Visibility',
        summaryBanner: 'Banner',
        approvalsTitle: 'Approvals',
        approvalsColSolicitante: 'Requested by',
        approvalsColAprobador: 'Approver',
        approvalsColFecha: 'Date',
        approvalsColEstado: 'Status',
        approved: 'Approved',
        pending: 'Pending',
        rejected: 'Rejected',
        approvalsEmpty: 'No exceptions to approve yet.',
        pendingBanner: 'You have {{count}} exception(s) waiting for your approval.',
        approve: 'Approve',
        reject: 'Reject',
        rejectReason: 'Reason for rejection (required)',
        rejectConfirm: 'Confirm rejection',
        back: 'Exceptions by OU',
        wizardTitle: 'Exception by OU — Fundamentals',
        wizardTitleBrillamos: 'OU exception — Shine Together',
        stepScope: 'Scope',
        stepSchedule: 'Schedule',
        stepBanner: 'Banner',
        // Bug UAT #114 — la «campaña por OU» sobreescribe una campaña activa; sin una debajo no hace nada.
        baseCampaignTitle: 'Base campaign',
        baseCampaignHint: 'An OU exception does not work on its own: it OVERRIDES parts of an active campaign for your scope. If no active campaign covers those OUs, this exception will have no effect. If you need a complete campaign of your own for the OU, create it from Campaigns, not here.',
        baseCampaignLabel: 'Campaign being overridden',
        baseCampaignNone: 'Not declared (applies to whichever active campaign covers the scope)',
        baseCampaignNinguna: 'There is no active Shine Together campaign. Create and activate one first, or this exception will not apply to anyone.',
        baseCampaignRequerida: 'Choose the base campaign before saving: without it the exception would not apply to anyone.',
        baseCampaignVentana: 'The base campaign runs from {{inicio}} to {{fin}}. These dates belong to the campaign and are not edited here.',
        baseCampaignSinVentana: 'The base campaign has no date range defined.',
        scheduleWindow: 'Local exception date and time',
        scheduleStart: 'Exception start',
        scheduleEnd: 'Exception end',
        scheduleTz: 'Time zone',
        scheduleRestrictTitle: 'Disable recognitions',
        scheduleRestrictNote: 'When active, recognitions cannot be sent outside the date and time configured for this scope. Requires Global Admin approval.',
        scheduleWindowNota: 'If you set a window, sends for this scope will be restricted to it. Leave it empty to apply no restriction.',
        scheduleInvalid: 'The schedule window requires a start and end date/time, and the end must be after the start.',
        bannerTitle: 'Shine Together banner (override)',
        bannerIntro: "Overrides the subtitle and logo of the Shine Together banner only for the scope of this exception. If you don't edit any language here, the global banner stays as is.",
        bannerScopeLabel: 'This banner applies only to the scope of this exception, not to the global Shine Together banner.',
        stepDocs: 'Documents',
        stepVisibility: 'Visibility',
        scopeIntro: 'Define the organizational scope.',
        docsIntro: 'Attach documents specific to this exception by OU.',
        entryPoints: 'Entry Points',
        entryPointMode: 'Enabled entry points (override)',
        entryPointModeApp: 'Form only',
        entryPointModePostit: 'Interactive post-it only',
        entryPointModeAmbos: 'Both',
        visTitle: 'Recognition visibility (override)',
        visIntro: 'Configure what information is shown to the user when receiving or viewing a recognition.',
        visText: 'Show recognition text/comment',
        visFundamental: 'Show assigned fundamental',
        visSender: 'Show sender name',
        visHabit: 'Show selected Daily Habit',
        visRanking: 'Show ranking of other OUs',
        visMultiFund: 'Allow multiple Fundamentals per recognition',
        maxFundamentales: 'Max. Fundamentals per recognition',
        rulesTitle: 'Send rules (override)',
        ruleMultiPersona: 'Multi-person',
        ruleComment: 'Comment required',
        ruleMinChars: 'Min. characters',
        ruleCsv: 'CSV upload',
        modTitle: 'Moderation (override)',
        modReport: 'Report button',
        modEditDelete: 'Edit and Delete buttons (sent only)',
        streakTitle: 'Streak (override)',
        streakMin: 'Min. sends/week',
        streakPeriod: 'Period',
        limitsTitle: 'Caps (override)',
        limitMax: 'Max. recos',
        limitFreq: 'Frequency',
        approvalRequiredTitle: 'Approval required',
        approvalRequiredMsg: 'All changes must be approved by the Global Admin before they take effect.',
      },
      // C2/P17 — Frecuencia declarativa; el vocabulario sale del Excel del cliente.
      fieldFrecuencia: 'Frequency',
      frecuenciaPlaceholder: 'e.g. Monthly, Every 3 meetings…',
      frecuencia: {
        mensual: 'Monthly',
        trimestral: 'Quarterly',
        cadaNReuniones: 'Every 3 meetings',
        porEvento: 'Per event',
      },
      // C2/P18-bis — deshacer un panico accidental (24 h, misma OU libre).
      undoPanic: 'Reactivate campaign',
      undoPanicConfirm: 'This campaign will be reactivated and visible again in its scope. Only possible within 24 h of the panic. Continue?',
      // C2/P19 — meta de participantes; la ayuda repite la DEFINICIÓN a propósito.
      fieldMetaParticipantes: "Participant goal",
      metaParticipantesInherit: "No goal",
      metaParticipantesHelp: "Distinct people taking part, either recognising or being recognised. Empty = no goal.",
      // WP-15 Task 9 — per-toggle help tooltips (AdminVistas pattern). One key per concept; exception
      // variants reuse the same key as their equivalent in the main wizard.
      tooltip: {
        entryPoints: 'How people can recognize others: classic form, interactive post-it, or both at once.',
        ruleMultiPersona: 'Allows including more than one person as a recipient in a single recognition.',
        ruleMultiFundamental: 'Allows tagging more than one Fundamental in the same recognition.',
        commentRequired: 'Requires writing a comment before the recognition can be sent.',
        ruleBulkCsv: 'Enables bulk-uploading recognitions via CSV file.',
        ruleReactions: 'Allows other people to react to a recognition with emoji.',
        ruleSendingDisabled: 'Turns off sending recognitions entirely for this scope, without affecting ones already sent.',
        ruleAnonymousEnabled: "Allows sending a recognition without showing the sender's name.",
        modPostEdit: 'Allows editing a recognition after it was sent, within the edit window.',
        antiSpoiler: "Hides recent recognitions on Home so surprises aren't spoiled before closing.",
        streakActive: 'Activates the weekly recognition streak count for this campaign.',
        dailyHabitsMandatory: 'Requires tagging a daily habit for the recognition to count toward the streak.',
        streakInProfile: "Shows the current streak on the user's public profile.",
        badgesActive: 'Activates awarding badges for meeting streak goals.',
        limitsActive: 'Activates the sending caps configured below, for recognitions and for Fundamentals.',
        recognitionsLimitActive: 'Applies the recognitions-per-period cap to this scope.',
        recognitionsLimitDisabled: 'Check "Not applicable" so this campaign has NO total send limit: a person can send as many recognitions as they want in the period, regardless of the global limit in Management. Leave it unchecked (and the field empty) to use the global limit.',
        streakMinimum: 'Minimum recognitions a person must SEND in the period for it to count toward their streak (1-20). Overrides the global minimum from Management for this campaign only; empty = the global applies. Cannot be changed once the campaign has started.',
        recognitionsLimitOwn: 'Maximum TOTAL recognitions a person can send in the period (to anyone, any fundamental). Overrides the global limit from Management for this campaign only; empty = the global applies. Editable at any time, even after the campaign has started.',
        sameFundamentalLimit: 'How many TIMES a person can recognize another on the SAME fundamental in the period (to the same person). Overrides the global value from Management for this campaign only; empty = the global applies. In Europe the legal minimum (GDPR) is kept.',
        sameFundamentalLimitDisabled: 'Check "Not applicable" to allow repeating the same fundamental to the same person with NO limit, regardless of the global. Leave it unchecked (and the field empty) to use the global. In Europe the legal limit is kept even if checked.',
        fundamentalsLimitActive: 'Applies the Fundamentals-per-submission cap to this scope.',
        designShowStreak: "Shows the streak block on this campaign's landing page.",
        designShowRecent: "Shows recent recognitions on this campaign's landing page.",
        visSender: 'Shows the name of the person sending the recognition.',
        visFundamental: 'Shows the Fundamental tagged in the recognition.',
        visText: "Shows the recognition's text or comment.",
        visHabit: 'Shows the selected daily habit, if any.',
        visSent: 'Shows the sent-recognitions tab.',
        visReceived: 'Shows the received-recognitions tab.',
        visBulk: 'Enables bulk CSV upload only for this campaign.',
        visReactions: 'Enables emoji reactions only for this campaign.',
        visCampaignTag: 'Shows the campaign name tag on each post-it.',
        visFromFundamentals: 'Allows starting this recognition from the Fundamentals screen.',
        visSendingDisabled: 'Turns off sending recognitions only for this campaign.',
        applyPoints: 'Recognitions in this campaign award redeemable points. Cannot be turned off once the campaign has started.',
        visRanking: 'Shows the ranking compared with other OUs.',
        visMultiFund: "Allows tagging more than one Fundamental, as this OU's exception.",
        modReport: 'Allows reporting an inappropriate recognition.',
        modEditDelete: 'Enables editing and deleting an already-sent recognition, only for this OU. The backend handles both permissions as a single switch.',
        scheduleEnabled: 'Restricts sending recognitions to the time window defined above.',
        disableSend: 'Blocks sending recognitions for this specific scope.',
        paisActive: 'If turned off, the campaign stops being active for this country even while the configured date and time window is still open.',
        paisApplySchedule: "When off, this row's date and time stay saved but are NOT applied: the country has no schedule restriction. Use it to prepare a window and switch it on later without typing it again.",
      },
      tooltipAria: 'Help',
    },
    reports: { desc: 'Program reporting and analytics.' },
    translate: {
      button: 'Translate to the other languages',
      buttonFrom: 'Translate from {{lang}} to the other languages',
      loading: 'Translating…',
      hint: 'Enter at least one language to translate.',
      error: 'Automatic translation failed.',
      sessionExpired: 'Your session expired. Please reload the page and sign in again.',
    },
    misSolicitudes: {
      title: "My Campaign Requests",
      desc: "The status of what you have proposed. You can withdraw a request while it is still pending, and resubmit it if it was rejected.",
      empty: "You have not sent any requests yet.",
      colCampana: "Campaign",
      colFecha: "Request date",
      colEstado: "Status",
      colComentario: "Comment",
      colAcciones: "Actions",
      editar: "Edit",
      retirar: "Withdraw request",
      reenviar: "Resubmit",
      estado: {
        pendiente: "Pending",
        aprobada: "Approved",
        rechazada: "Rejected",
      },
    },
    management: {
      desc: 'Sending rules, caps and streak.',
      title: 'Management',
      descLong: 'Global settings: streak description ×7, badges, global toggles and freeze. Atomic save.',
      fixValidation: 'Fix the validations before saving.',
      streakDescription: 'Streak description',
      fundamentalsTitle: 'Available Fundamentals',
      fundamentalsDesc: 'Which Fundamentals are offered when recognizing. Removing one does not delete it from the catalog: it stops appearing in this program.',
      fundamentalsLastOne: 'This is the last available one: removing it would leave nobody able to send a recognition.',
      avatarTitle: 'Avatar settings (Frontline)',
      avatarDesc: 'Frontline users signing in through the webapp can customize a colour avatar. Those who come in through Teams keep their profile picture.',
      avatarEnabled: 'Customizable avatar enabled',
      avatarSelector: 'Show selector after sign-up',
      avatarColors: 'Available colours:',
      placeholderTitle: 'Configurable description of the text field',
      placeholderDesc: 'The helper text of the message field when recognizing. Every language you leave empty uses the product default.',
      placeholderLabel: 'Message helper text',
      panicTitle: 'Panic Button — Brillamos Juntos',
      panicDesc: 'Immediately disables sending recognitions across all active campaigns. It applies to both Shine Together and Recognize (Fundamentals). General Admin only.',
      panicToggle: 'Brillamos Global Kill Switch',
      panicActiveHint: 'Sending is DISABLED: nobody can send recognitions right now.',
      panicSameSwitchHint: 'This is a global switch: while it is on, no per-programme or per-campaign setting can re-enable sending.',
      panicNoActiveCampaign: 'This switch becomes available once at least one Shine Together campaign is active (RN-C08). There are none right now, so there are no campaign submissions to stop.',
      needAllLangs: 'Complete all 7 languages.',
      globalToggles: 'Global toggles',
      streakEnabled: 'Streak enabled',
      multinomination: 'Multi-nomination',
      dailyHabitsMandatory: 'Daily habits mandatory',
      antiSpoiler: 'Anti-spoiler',
      antiSpoilerTitle: 'Anti-Spoiler Mode (Awards)',
      antiSpoilerDesc: 'Temporarily hides other people’s profiles and recognitions during the annual awards, so the winners are not revealed.',
      antiSpoilerActivo: 'Anti-spoiler on',
      antiSpoilerFrom: 'From',
      antiSpoilerTo: 'To',
      antiSpoilerHint: 'While it is on, employees cannot see colleagues’ profiles or the detail of other people’s recognitions.',
      antiSpoilerSinVentana: 'With no dates, it protects for as long as the switch is on.',
      antiSpoilerVentanaInvertida: '“From” is later than “To”: a window like that never protects. Fix it to save.',
      wrappedByOu: 'Wrapped by OU',
      reactionsEnabled: 'Reactions (👏❤️😊🎉👍)',
      allowPromoteToBrillamos: 'Allow sending to Brillamos',
      allowPostEdit: 'Post-submit editing',
      postEditTitle: 'Editing Sent Recognitions',
      postEditDesc: 'Lets the sender edit the message of a recognition already sent. Off by default.',
      postEditWindow: 'Editing window',
      postEditWindowOpt: { '24h': '24 hours', '48h': '48 hours', '7d': '7 days', unlimited: 'No limit' },
      streakPerPersonCapEnabled: 'Per-person streak cap',
      streakPerPersonCap: 'Max per person (streak)',
      weeklyMinimum: 'Minimum per period',
      periodicity: 'Periodicity',
      period: { weekly: 'Weekly', monthly: 'Monthly' },
      periodicityHint: 'The minimum applies to the chosen period: with Monthly, the streak adds up or breaks per calendar month, not per week.',
      periodicityMonthlyWarning: 'With Monthly the streak counts consecutive MONTHS and the app already reflects that (widget, Profile, Wrapped and thresholds). TWO Product decisions remain before enabling it in production: RF-038 defines badge thresholds in weeks (1/4/8/12/20), so the 4 badge would be reached after 4 months; and the anti-abuse cap of 2 recognitions per person moves from per week to per month, which can make a high minimum unreachable in small teams.',
      freezeFrom: 'Freeze from',
      freezeTo: 'Freeze to',
      badges: 'Badges',
      noBadges: 'No badges configured.',
      badge: 'Badge',
      weeksRequired: '{{count}} weeks',
      weeksRequiredOne: '{{count}} week',
      weeksRequiredMany: '{{count}} weeks',
      badgeName: 'Badge name',
      badgeIcon: 'Icon',
      badgeColor: 'Color',
      weeks: 'Weeks required',
      notApplicable: 'Not applicable',
      iconFormatInvalid: 'Invalid image format. Use PNG, JPG, WEBP or SVG.',
      addBadge: '+ Add badge',
      editBadge: 'Edit',
      deleteBadge: 'Delete',
      deleteBadgeConfirm: 'Delete the badge “{{name}}”? Its name in all 7 languages, its icon and its threshold will be lost. The deletion takes effect when you save.',
      badgeActive: 'Active',
      badgeInactive: 'Inactive',
      imageUploadHintNew: 'Save the badge first to be able to upload the icon.',
      previewTitle: 'Preview',
      saveBadgeChanges: 'Save changes',
    },
    // PHASE 7 (demo parity, H-93/H-94/H-95) — Admin › Notifications (REQ-135).
    notifications: {
      title: 'Notification Settings',
      desc: 'Configure which email notices are sent and at which level of the organisation. Values not defined at this level are inherited from the next one.',
      precedenceTitle: 'How settings are resolved',
      precedence1: 'Precedence: Site > BU > OU > Global. The value defined at the most specific level wins.',
      precedence2: 'An «Inherited» toggle is not off: it takes the value from the level below. Only what you define here is saved.',
      precedence3: 'People can also turn off their own emails from their profile; that preference never re-enables what is switched off here.',
      scopeTitle: 'Configuration level',
      scopeUnit: 'Unit',
      scopePick: 'Select a unit…',
      scopeRequired: 'Select a unit to view and edit its settings.',
      scopeOuContext: 'OU of the unit',
      scopeOuFirst: 'Select an OU first…',
      unsavedLock: 'You have unsaved changes; the level stays fixed until you save or discard them.',
      discard: 'Discard changes',
      scope: { global: 'Global (whole tenant)', ou: 'OU', bu: 'Business Unit', site: 'Site' },
      group: { email: 'Email', categories: 'Notice types', summary: 'Periodic summary', blocked: 'Blocked emails' },
      blocked: {
        desc: 'Addresses that will not receive any programme email, whatever their personal settings say.',
        scopeWarning: 'Blocking applies to the WHOLE tenant, not just this level: an email blocked here is blocked across every OU. It also overrides the master switch.',
        placeholder: 'name@company.com',
        add: 'Block',
        remove: 'Unblock {{email}}',
        empty: 'No blocked emails.',
      },
      design: {
        title: 'Email design',
        desc: 'This is how they look today: Fundamentals use a warm style and Shine Together a dark one with stars. Each email\'s design is set in the template itself, not from here.',
        fund: { name: 'Fundamentals', style: 'Warm style · Cream/Orange' },
        shine: { name: '✨ Shine Together', style: 'Dark style · Stars/Purple' },
      },
      broadcast: {
        title: 'System notices',
        desc: 'For maintenance, outages or any one-off notice. It\'s sent with the template already designed: just write the message.',
        overridesHint: '🔴 This notice reaches EVERYONE, even people who turned their notifications off. It isn\'t programme content: it\'s information about the tool.',
        kindLabel: 'Notice type',
        kind: { maintenance: 'Scheduled maintenance', suspension: 'Temporary outage', restored: 'Service restored', general: 'General notice' },
        subject: 'Subject',
        subjectPlaceholder: 'Scheduled maintenance — Saturday 2am',
        message: 'Message',
        messagePlaceholder: 'Message for users...',
        everyone: 'Everyone',
        singleOu: 'A specific OU',
        chooseOu: 'Choose an OU',
        send: 'Send notice now',
        error: 'The notice could not be sent.',
        sentSummary: 'Sent to {{sent}} of {{recipients}} people.',
        skipped: '· {{count}} with unresolvable identity did not receive it.',
      },
      channel: { inapp: 'Bell', email: 'Email', teams: 'Teams' },
      tables: {
        shine: '✨ Notifications — Shine Together',
        admin: '🛡️ Notifications — Admin',
        colType: 'Type',
        colSubject: 'Subject (ES)',
        colLanguages: 'Languages',
        editSubject: 'Edit the subject of “{{row}}” in all 7 languages',
        subjectByLanguage: 'Subject by language',
        close: 'Close',
        saveSubject: 'Save subject',
        nineRows: 'Nine rows, not thirteen: four of the ones the mockup draws don\'t match any notice the system sends today.',
        rows: {
          'campaign-new': { name: 'New campaign launched', trigger: 'An admin activates a campaign' },
          'campaign-ending': { name: 'Campaign ending soon', trigger: 'Last days to nominate' },
          'recognition-sent': { name: 'Recognition sent to Shine Together', trigger: 'Confirmation that it counted toward the campaign' },
          'ranking-position': { name: 'Ranking position', trigger: 'You move up the leaderboard' },
          'campaign-approval': { name: 'Local campaign request', trigger: 'An OU admin creates a request → Global admin' },
          'moderation-case-alert': { name: 'Moderation report', trigger: 'A new report is pending for the OU admin' },
          'moderation-educational': { name: 'Reported message, notice to the sender', trigger: 'Tells whoever sent the recognition that it was reported' },
          'low-participation-alert': { name: 'Low participation alert', trigger: 'A campaign is below the participation threshold' },
          'pending-nomination-manager': { name: 'Pending nomination (manager)', trigger: 'A nomination needs approval' },
        },
      },
      master: {
        label: 'Email Notifications',
        desc: 'Master switch: when off, no programme email is sent at this scope. Does not affect Teams or the bell.',
      },
      cat: {
        recognitionReceivedEnabled: { label: 'Recognitions received', desc: 'Notice to a person when someone recognises them.' },
        streakAndBadgesEnabled: { label: 'Streaks and badges', desc: 'Streak reminders and unlocked badges.' },
        campaignsEnabled: { label: 'Campaigns', desc: 'New campaign, ending campaign, winners and approvals.' },
        digestEnabled: { label: 'Weekly digest', desc: 'Digest with the activity accumulated over the week.' },
      },
      monthly: {
        label: 'Monthly summary',
        desc: 'Off by default. Turn it on only if this unit also wants a monthly summary.',
      },
      masterOffHint: 'Individual types only operate with the master switch on.',
      inherited: 'Inherited',
      inApp: { label: 'In-app notifications (bell)', desc: 'The portal bell. It does not depend on the email switch: it is a separate channel.' },
      teams: { label: 'Teams Activity Feed', desc: 'The notice in the Teams activity feed, for people with a corporate account.' },
      frequency: {
        label: 'Sending frequency (email)',
        desc: 'How often notices are grouped into a digest. Per-event emails are not affected.',
        opt: {
          immediate: 'Immediate (per event)',
          daily: 'Daily digest',
          weekly: 'Weekly digest',
          biweekly: 'Biweekly digest (every 2 weeks)',
        },
        immediateHint: 'With “Immediate” no digest is sent at all, even if its category stays on: each notice goes out on its own.',
      },
      resetToInherited: 'Back to inherited',
      active: 'active',
      saved: 'Changes saved!',
      loadError: 'Could not load the settings for this level.',
      saveError: 'Could not save the settings. Please try again.',
    },
    views: {
      title: 'User Views',
      desc: 'Employee-facing views and microsites.',
      descLong: 'Which views each OU offers its people. Desktop + mobile ready.',
      scope: 'Configuration level',
      scopeGlobal: 'Global (all OUs)',
      unsavedLock: 'Save or discard your changes before switching level.',
      infoAria: 'Help about {{label}}',
      micrositesTitle: 'Microsite URLs per Fundamental',
      micrositesDesc: 'External link with more about each Fundamental. Leave empty if there is no microsite.',
      card: {
        medallero: { label: 'Medal board', desc: 'Sent + received' },
        perfilUsuario: { label: 'User profile', desc: 'Received newest→oldest' },
        enviarReconocimiento: {
          label: 'Send recognition', desc: 'As configured by the admin',
          tooltip: "Shows the button and form to recognize a teammate. It combines with the general sending switch: if that one is off, this view won't appear even if it's on here.",
        },
        historicoPorAnio: {
          label: 'History by year', desc: 'Current year first',
          tooltip: 'Lets people see their recognition history grouped by year, current year first. It also depends on the active campaign having history enabled.',
        },
        leaderboard: {
          label: 'Leaderboard', desc: 'Ranking',
          tooltip: 'Shows the ranking of who has sent or received the most recognitions. It is the only view that starts off by default.',
        },
        feedActividad: { label: 'Activity feed', desc: 'Recent timeline' },
        resumenMensual: {
          label: 'Monthly wrap-up', desc: 'Spotify-style wrap-up',
          tooltip: "Turns on the Spotify-style 'Wrapped' summary with each person's numbers for the period. It only shows if Wrapped is enabled for the OU and the campaign has already closed.",
        },
        busquedaCompaneros: {
          label: 'Peer search', desc: 'See other people’s medal boards',
          tooltip: "Lets people search for and see other teammates' medal boards. It's automatically hidden while Anti-Spoiler Mode is active, so it doesn't spoil surprises before an award ceremony.",
        },
        vistaFundamentales: {
          label: 'Fundamentals view', desc: 'Info on each fundamental',
          tooltip: 'Shows the constellation with information about each culture Fundamental inside the Shine Together screen.',
        },
        banderaReportar: {
          label: 'Report flag', desc: 'Report inappropriate recognitions',
          tooltip: 'Adds a button so people can report an inappropriate recognition. It also depends on the "Report button" toggle being enabled in Moderation.',
        },
        recordatorioDiario: { label: 'Daily reminder', desc: 'Daily nudge to recognize' },
        verATuEquipo: {
          label: 'See your team', desc: 'Leaders/managers only',
          tooltip: 'Lets leaders and managers see the recognitions of the people they manage. Only applies to someone who is a leader in the org chart and has the team metrics permission.',
        },
      },
      compose: {
        sending: 'Also depends on the panic switch: with sending disabled, this view does not appear even if enabled here.',
        campaign: 'Also depends on the history toggle of the active campaign (RN-PR09).',
        wrapped: 'Also depends on the OU having Wrapped enabled and its campaign being closed.',
        antiSpoiler: 'Also depends on Anti-Spoiler mode: while its window is active, this view is hidden.',
        report: 'Also depends on the “Report button” toggle in the Moderation section.',
        manager: 'Also depends on being a leader in the org chart and having the team metrics permission.',
      },
    },
    docs: {
      desc: 'Corporate and legal documents.',
      legalTab: 'Legal terms',
      privacyTab: 'Privacy notice',
      corpTab: 'Corporate',
      pillsTab: 'User Pills',
      bibliotecaTab: 'Library',
      legalesTab: 'Legal Docs',
      gestionTitle: 'Documentation Management',
      gestionDesc: 'Configure user quick links, manage the file library and the mandatory legal documents.',
      pills: {
        nueva: 'Add Pill',
        sectionTitle: 'Quick Access (Pills)',
        sectionSubtitle: 'Quick-access capsules shown in the user interface. Set the name, icon, color and the content they open on click.',
        editar: 'Edit pill',
        titulo: 'Title',
        tipo: 'Type',
        tipos: { documento: 'Document', url: 'Link', video: 'Video' },
        icono: 'Icon',
        color: 'Color',
        orden: 'Order',
        documento: 'Corporate document',
        elegirDocumento: 'Choose document…',
        sinDocumentos: 'No corporate documents available. Upload them in the Corporate tab.',
        url: 'Target URL',
        visibilidad: 'Visibility by OU',
        visibilidadHint: 'No OU selected = visible to all units.',
        activa: 'Active pill (shown in the rail)',
        activaSi: 'Active',
        activaNo: 'Inactive',
        estado: 'Status',
        vistaPrevia: 'Preview',
        nombre: 'Name',
        tipoContenido: 'Content type',
        documentoColumna: 'Linked document',
        documentoNoEncontrado: 'Document not found',
        documentoAlcanceIncompleto: "Doesn't cover all of this pill's OUs",
        sinTitulo: 'Untitled',
        todas: 'All',
        vacio: 'No quick links configured yet.',
        eliminar: 'Delete pill',
        eliminarConfirm: 'Delete this quick link from the rail?',
        errorCargar: 'Could not load the quick links.',
        errorGuardar: 'Could not save the quick link.',
        errorEliminar: 'Could not delete the quick link.',
      },
      corp: {
        firstLogin: 'First login',
        versionEs: 'Version ES',
        versionEn: 'Version EN',
        subirVersion: 'Upload',
        reemplazar: 'Replace',
        verVersion: 'View version',
        quitarVersion: 'Remove version',
        triggerUpdate: 'Trigger update',
        ousActivas: 'Active OUs',
        nombre: 'Document name',
        tipo: 'Type',
        visibilidad: 'Visibility by OU',
        idiomas: 'Languages',
        idiomasHint: 'No selection = all languages.',
        versionesPorIdioma: 'Versions by language',
        versionesPorIdiomaCount: 'Versions ({{count}}/{{total}})',
        archivo: 'PDF file',
        elegirArchivo: 'Choose PDF…',
        subir: 'Upload document',
        agregarDocumento: 'Add Document',
        subirArchivo: 'Upload File',
        libType: { todos: 'All', pdf: 'PDF', video: 'Video', imagen: 'Image' },
        filterType: 'Type',
        nombreArchivo: 'File name',
        idioma: 'Language',
        pillAsignado: 'Assigned pill',
        subido: 'Uploaded',
        documento: 'Document',
        actualizado: 'Updated',
        mediaKind: 'File type',
        externalUrl: 'External URL',
        externalUrlHint: 'Paste the video or image link (Teams, SharePoint, etc.).',
        requiereUrl: 'Enter a valid external URL.',
        abrir: 'Open',
        dropMain: 'Drag files here or click to upload',
        dropSub: 'PDF · Max. 25 MB per file',
        subidoOk: 'Document uploaded.',
        errorSubir: 'The document could not be uploaded.',
        lista: 'Uploaded documents',
        listaCount: '{{count}} documents configured',
        legalInfo: 'These documents are shown in the mandatory acceptance modal. First login activates them on the first access. Trigger update shows them again even if the user already accepted them. Explicit acceptance is required to continue.',
        searchPlaceholder: 'Search file…',
        filterLang: 'Filter by language',
        filterLangAll: 'All languages',
        noResults: 'No documents match the filter.',
        vacio: 'There are no corporate documents yet.',
        fecha: 'Date',
        acciones: 'Actions',
        descargar: 'Download',
        editar: 'Edit',
        eliminar: 'Delete',
        guardar: 'Save changes',
        cancelar: 'Cancel',
        eliminarConfirm: 'Delete this document from the repository?',
        errorEliminar: 'The document could not be deleted.',
        errorActualizar: 'The document could not be updated.',
        errorCargar: 'The list could not be loaded.',
        soloPdf: 'Only PDF up to 25 MB is allowed.',
        requiereNombre: 'Enter a name.',
        requiereOu: 'Select at least one OU.',
        requiereArchivo: 'Choose a PDF file.',
        tipos: {
          PoliticaPrivacidad: 'Privacy Policy',
          BasesLegales: 'Legal Terms',
          GuiaUsuario: 'User Guide',
          Premios: 'Prizes',
          CookiesPolicy: 'Cookies Policy',
          LegalNotice: 'Legal Notice',
        },
      },
      currentVersion: 'Current version',
      noVersionYet: 'No version has been published yet',
      newVersionLabel: 'New version to publish',
      loadError: 'The draft could not be loaded.',
      titleLabel: 'Title',
      sectionHeading: 'Heading',
      sectionBody: 'Body',
      addSection: 'Add section',
      removeSection: 'Remove section',
      saveDraft: 'Save draft',
      publish: 'Publish',
      publishConfirm: 'You are about to publish a new version. All users will need to accept it again before they can give recognition. Continue?',
      missingLanguages: 'Missing languages: {{languages}}',
      draftSaved: 'Draft saved',
      published: 'Version published',
      saveError: 'The draft could not be saved.',
      publishError: 'The version could not be published.',
    },
    recap: {
      title: 'Annual Recap',
      desc: 'Configure the Recap experience per edition. Backgrounds and icons are set per slide; user data (recognitions, top Fundamental, #1 fan, streak) is injected automatically by the platform.',
      deniedRole: 'Recap management is reserved for the General Admin and the Fundamentals Admin.',
      fixValidation: 'Complete the required texts before saving.',
      noEditions: 'There are no Recap editions yet.',
      createFirst: 'Create the first edition',
      edition: 'Edition',
      editionName: 'Name shown to the user',
      newEdition: 'New edition',
      scope: 'OU scope',
      scopeGlobal: 'Global (all)',
      active: 'Recap active',
      activeOn: 'Active',
      activeOff: 'Inactive',
      visibleFrom: 'Visible from',
      visibleTo: 'Visible until',
      notification: 'Notification',
      notifiedAt: 'Sent {{date}}',
      neverNotified: 'Not notified',
      difusionLockHint: 'This Recap has already been announced. You can WIDEN its scope and visibility window, but not shrink them: removing an OU or shortening the dates would exclude people who were already notified. Everything else stays editable.',
      slidesTitle: 'Slide configuration ({{count}} slides)',
      slidesHint: 'Fundamental icons and user data are injected automatically. Here you only configure the visual layer and the texts.',
      i18nHint: 'Multilingual: each slide title is captured in all 7 languages from the Edit button.',
      colSlide: 'Slide',
      colPreview: 'Preview',
      colTitle: 'Title',
      colActive: 'Active',
      colActions: 'Actions',
      edit: 'Edit',
      titleMissing: 'No title',
      needAllLangs: 'Some languages are missing (all 7 are required).',
      slides: {
        portada:    { name: 'Cover',                hint: 'Welcome screen' },
        numeros:    { name: 'Your year in numbers', hint: 'Received + sent' },
        define:     { name: 'What defines you',     hint: 'Most received Fundamental (automatic data)' },
        mensaje:    { name: 'The message',          hint: 'Longest recognition (automatic data)' },
        quienes:    { name: 'Who recognized you',   hint: 'Totals and people (automatic data)' },
        red:        { name: 'Your network',         hint: 'Distinct areas that recognized you (automatic data)' },
        constancia: { name: 'Your consistency',     hint: 'Weekly streak (automatic data)' },
        reto:       { name: 'Next year challenge',  hint: 'Least shown Fundamental and call to action' },
        ganador:    { name: 'Annual Winner',        hint: 'If the user won: real badge from the Winners section' },
      },
      notifyTitle: 'Recap notification',
      notifyDesc: 'Let everyone in the selected scope know their {{year}} Recap is ready.',
      preview: 'Preview',
      send: 'Send notification',
      notifyNeedsActive: 'Activate the edition before notifying it.',
      notifyError: 'The notification could not be sent.',
      previewNote: 'This is how the edition plays: only active slides, with their backgrounds and titles. Numbers belong to whoever opens it.',
      genericTitle: 'Generic message (fallback)',
      genericDesc: 'Shown when the user has no recognitions in the period, or enters before the Recap is visible.',
      genericTitleLabel: 'Generic message title',
      genericDescLabel: 'Subtitle / description',
      genericNote: 'This message is the fallback: anyone with data sees their personalized Recap.',
      imageUrlPlaceholder: 'Image URL (PNG / JPG)',
      historyTitle: 'Recap history and annual winners',
      historyDesc: 'Registered editions and the annual winners linked to each one.',
      colEdition: 'Edition',
      colYear: 'Year',
      colScope: 'Scope',
      colSlides: 'Slides',
      colWinners: 'Annual winners',
      colStatus: 'Status',
      winnersCount: '{{count}} winners',
      status: { activa: 'Active', completada: 'Completed', borrador: 'Draft' },
      editorTitle: 'Edit slide {{index}}',
      editorDescData: 'Set the title (7 languages), the background and the text next to the dynamic data. The preview updates as you type.',
      editorDescIcon: 'Set the title (7 languages), the background and the slide icon. The preview updates as you type.',
      titleLangs: 'Title (7 languages)',
      titlePlaceholder: 'Title in {{lang}}',
      autoIcon: 'The icon of this slide is automatic: it uses the real winner badge configured in Winners.',
      icon: 'Icon',
      iconPlaceholder: 'Emoji or image URL',
      numberLabels: 'Text under the numbers',
      numberLabelsHint: 'The platform calculates the numbers; here you define the word underneath.',
      numberLabelPlaceholder: 'e.g. received',
      background: 'Background',
      previewLabel: 'Preview',
      previewDataNote: 'The numbers shown belong to the user opening their Recap.',
      apply: 'Apply',
    },
  },
  // ── WP-16 REQ-140 — Legal modals ──
  legal: {
    privacy: 'Privacy Policy',
    legal: 'Program Legal Terms',
    reachedEnd: "You've reached the end!",
    scrollHint: 'Scroll to the bottom to accept',
    accept: 'I Accept',
    acceptError: 'Your acceptance could not be recorded.',
    loadError: 'The document could not be loaded.',
    pdfError: "Couldn't display the PDF document.",
    retry: 'Retry',
    openInNewTab: 'Open in a new tab',
  },
  // ── WP-16 REQ-139 — Standalone Frontline registration ──
  register: {
    backToLogin: '← Back to sign in',
    entraTitle: 'Already have an institutional email?',
    entraSub: "You don't need to register — sign in directly with your Sigma account.",
    title: 'Registration',
    subtitle: 'Create your access to the Recognition Program.',
    fullName: 'Full name',
    email: 'Email address',
    ou: 'Organizational unit',
    selectOu: 'Select your OU',
    startDate: 'Start date at Sigma',
    employeeId: 'Payroll number',
    bu: 'Business unit',
    site: 'Workplace',
    department: 'Department',
    selectBu: 'Select your Business Unit',
    selectSite: 'Select your workplace',
    selectDepartment: 'Select your department',
    errName: 'Enter your full name.',
    errEmail: 'Enter a valid email address.',
    errOu: 'Select your OU.',
    errCatalogs: 'Complete business unit, workplace and department.',
    errStartDate: 'Enter your start date.',
    errEmployeeId: 'Enter your payroll number.',
    catalogsError: 'The catalogs could not be loaded.',
    submit: 'Register',
    submitError: 'Registration could not be completed.',
    checkEmailTitle: 'Check your email',
    checkEmailSub: 'We sent a verification link to {{email}}.',
    verifyFailed: 'Your email could not be verified. The link may have expired.',
    verified: 'Email verified',
    allSet: "You're all set!",
    allSetSub: 'Your account is configured. You can now recognize your colleagues.',
    password: 'Password (min. 8 characters)',
    confirmPassword: 'Confirm password',
    errPassword: 'The password must be at least 8 characters long.',
    errPasswordMatch: 'The passwords do not match.',
    errLegal: 'You must accept the Legal Terms.',
    errLegalVersion: "Couldn't load the legal document. Please try again.",
    errPrivacy: 'You must accept the Privacy Notice.',
    errLocalId: 'Enter your Local ID (up to 8 digits).',
    errDepartment: 'Select your department.',
    acceptPrivacy: 'I have read and accept the',
    acceptLegalBases: 'I have read and accept the',
    privacyLink: 'Privacy Notice',
    legalLink: 'Legal Terms',
    localId: 'Local ID',
    policyPlaceholder: 'Read the full document. You will be able to accept it once you reach the end.',
    createdTitle: 'Account created',
    createdSub: 'You can now sign in with your email and password. Once inside, you can choose your avatar.',
    checkEmailHint: 'Open the link to confirm your email and be able to sign in. It expires in 72 hours.',
    resend: 'Resend the email',
    resendDone: "If your account is pending verification, we've sent you another link. If you already verified it, just sign in with your email and password.",
  },
  // ── Login (RF-002) ──
  login: {
    title: 'Sign in',
    subtitle: 'Recognition Program',
    entraRouteTitle: 'Sign in with your work email',
    entraRouteSub: 'Use your Sigma account (Entra ID).',
    entra: 'Sign in with Sigma email',
    frontlineRouteTitle: "Don't have a work email?",
    frontlineRouteSub: 'Sign in with your email and password.',
    email: 'Email',
    password: 'Password',
    submit: 'Sign in',
    submitting: 'Signing in…',
    or: 'or',
    toRegister: "Don't have an account? Register",
    noAccountLede: "Don't have an institutional account?",
    noAccountSub: 'Use a personal email',
    alreadyRegisteredLede: 'Already registered?',
    hasInstitutionalEmailLede: 'Do you have an institutional email?',
    register: 'Register',
    back: 'Back',
    forgot: 'Forgot your password?',
    forgotIntro: "Enter your email and we'll send you a link to create a new password.",
    forgotSubmit: 'Send me the link',
    forgotSent: "If that email is registered, we've sent you a link. It expires in 60 minutes.",
    resendVerification: "Didn't get the verification email?",
    resendIntro: "Enter your email and we'll send you another verification link.",
    resendSubmit: 'Resend the email',
    resendSent: "If your account is pending verification, we've sent you another link. If you already verified it, just sign in with your email and password.",
    errRequired: 'Enter your email and password.',
    errCredentials: 'Incorrect email or password.',
  },
  // ── Common landing (rule #3) ──
  landing: {
    question: 'What Fundamentals will we recognize today?',
    subtitle: 'Choose a space to live your Fundamentals',
    cardPulso: 'Post Meeting Pulse',
    cardShine: 'Shine Together',
    pulsoHover: 'How was your team in the last meeting? Tell them what you noticed 💬',
    shineHover: "Want to see who's shining and nominate a colleague?",
  },
  // Restablecimiento de contrasena Frontline (/app/restablecer)
  reset: {
    title: 'Create your new password',
    subtitle: 'Choose a password to get back in.',
    password: 'New password (min. 8 characters)',
    confirmPassword: 'Confirm password',
    submit: 'Change my password',
    errPassword: 'The password must be at least 8 characters long.',
    errPasswordMatch: "The passwords don't match.",
    errInvalidLink: 'The link is not valid or has expired. Request a new one from the sign-in page.',
    doneTitle: 'Password updated',
    doneSub: 'You can now sign in with your email and your new password.',
    noToken: 'Invalid link',
    noTokenSub: 'The link is not valid or is incomplete. Please check the email you received.',
  },
  auth: {
    retryIn: 'You can try again in {{seconds}} s',
    contactHR: 'If you have trouble registering, contact your Human Capital team.',
    errorTitle: "We couldn't continue",
  },
  // ── WP-16 REQ-141 — Avatar ──
  avatar: {
    title: 'Choose your avatar',
    subtitle: 'Pick the image that represents you.',
    loading: 'Loading avatars…',
    empty: 'No avatars available yet.',
    loadError: 'Avatars could not be loaded.',
    saveError: 'Your avatar could not be saved.',
    saved: 'Avatar saved',
    confirm: 'Confirm',
    required: 'Choose your avatar to continue.',
    unavailable: 'That avatar is no longer available. Please choose another one.',
    change: 'Change avatar',
    continueWithout: 'Continue without an avatar',
  },
  // ── WP-08 — Recognition Reports ──
  reports: {
    title: 'Reports',
    subtitle: 'Recognition Program analytics. Never shows points.',
    emptyScope: 'You have no organizational unit assigned within your scope.',
    tabs: {
      daily: 'Daily Reco',
      shine: 'Brillamos Juntos',
      history: 'History',
      heatmap: 'Heatmap',
      network: 'ONA Network',
      generational: 'Demographic',
      leaders: 'Leaders',
      moderation: 'Moderation',
      campaigns: 'Campaigns General',
    },
    common: {
      loading: 'Loading reports…',
      error: 'The report could not be loaded.',
      empty: 'No data for the selected filters.',
      retry: 'Retry',
      suppressedNote: 'Some aggregates were hidden by the anonymity threshold (fewer than 5).',
      suppressedNoteHelp: 'When a group has fewer than 5 people, its disaggregated metrics are not published: with so few, the data would make it possible to identify someone by inference. It is not an error or missing information.',
      colScope: 'Scope (units)',
      colScopeHelp: 'Organisational units the campaign was aimed at.',
      colAudienceHelp: 'Number of employees the campaign was aimed at. It is the denominator of the participation rate.',
      scopeAll: 'Whole organisation',
      scopeMore: '+{{n}} more',
      masked: 'Hidden for anonymity',
      showingRange: 'Showing {{desde}}–{{hasta}} of {{total}}',
      pageSize: 'Rows per page',
      perPage: '{{n}} per page',
      exportExcel: 'Export to Excel',
      yes: 'Yes',
      no: 'No',
    },
    context: {
      unifiedTitle: 'Unified metrics',
      unifiedText: '— Daily Reco and Brillamos Juntos use the same counting logic. The figures are consistent across modules.',
      auditTitle: 'Auditing on.',
      auditText: 'Every download is logged with your user, the tab and the date.',
      showing: 'Showing:',
      wholeOrg: 'the whole organisation',
    },
    filters: {
      allFundamentals: 'All Fundamentals',
      allOus: 'All OUs',
      dateFrom: 'From',
      dateTo: 'To',
      reset: 'Clear',
      ou: 'Unit',
      fundamental: 'Fundamental',
      dateRange: 'Dates',
      remove: 'Remove {{filter}} filter',
      person: 'Person',
      personPlaceholder: 'Search person…',
      personClear: 'Remove selected person',
      personNoResults: 'No matches in the directory',
      personSearching: 'Searching…',
      personError: 'Could not query the directory',
    },
    notApplicable: {
      title_one: 'The {{filtros}} filter does not apply in this section.',
      // `title_few` — inert alias of `title_other`, kept only for key parity with `ro` (the one
      // locale whose `Intl.PluralRules` actually selects "few" for a count of 2).
      title_few: 'The {{filtros}} filters do not apply in this section.',
      title_other: 'The {{filtros}} filters do not apply in this section.',
      and: 'and',
      reason: {
        embudo: 'The funnel splits the whole population into Regular, Occasional and Inactive; narrowed to a single person it would stop being a split.',
        historico: 'These figures are "ever", not of the chosen period: they count anyone who has ever recognized someone, across their entire history on the platform.',
        audienciaCampana: 'This indicator is calculated over the audience called by the campaign, which stays the same regardless of the Fundamental or person chosen.',
        porBanda: 'The distribution groups people by generational band; with a single person selected only one band would remain, and it would stop being a distribution.',
        porOu: 'This view groups by organizational unit, not by person.',
        redOu: 'The network nodes are organizational units, not people.',
        promedioPulso: 'This table comes from average Pulso scores (1-4) by generation and Fundamental, not from the recognition count or the headcount census: neither filter narrows it.',
        resumenCampana: 'This indicator comes from the summary of the whole campaign: the backend does not support narrowing it to a single person (it does support narrowing by Fundamental).',
        casosReportados: 'This report lists reported CASES, and the reason is written by whoever reports it: it is not tied to a Fundamental of the recognition. The OU, the date range and the person do narrow this table.',
      },
    },
    daily: {
      title: 'Daily Recognition',
      subtitle: 'Day-to-day recognitions only, campaigns excluded: selected vs. previous period, participation funnel and top lists.',
      // T-05 — el tab respeta el rango del filtro, así que la comparativa ya no es «semana»
      // fija: es el periodo elegido contra el anterior equivalente. Sin rango, sigue siendo
      // la semana en curso, que es el valor por omisión que pide la Especificación.
      thisPeriod: 'Selected period',
      prevPeriod: 'Previous period',
      vsPrev: '{{variacion}} vs. previous period · {{previo}}',
      fundamentalDistribution: 'Distribution by Fundamental',
      totalSentTitle: 'Total recognitions sent',
      totalSentHint: 'Sum of every recognition sent during the period',
      retiredFundamental: 'Retired fundamental',
      unresolvedFundamental: 'Fundamental (catalogue unavailable)',
      retiredFundamentalHint: 'Fundamental retired from the catalogue: it stays in the history because recognitions used it, but it can no longer be chosen.',
      adoptionStaff: 'Staff users',
      adoptionFrontline: 'Frontline users',
      adoptionTotal: 'Total users',
      noActivity: 'No activity',
      adoptionHint: '{{reconocedores}} of {{plantilla}} have recognized someone',
      adoptionTotalHint: '{{pct}} of total headcount ({{plantilla}})',
      noActivityHint: 'Have never sent a recognition',
      variation: 'Change',
      sparkAria: 'Daily trend for {{label}}: {{dias}} days, from {{primero}} to {{ultimo}}',
      uniquePeople: 'Unique people',
      pares: 'Peers',
      lideres: 'Leaders',
      funnel: 'Participation funnel',
      funnelMonthSelector: 'Participation funnel month',
      funnelRange: 'Range: {{from}} – {{to}}',
      funnelPeople: '{{count}} people',
      topPeople: 'Top recognized people',
      topRecognizers: 'Top recognizers',
      topFundamentals: 'Top fundamentals',
      // E6 — botón de export multi-hoja (7 hojas) del tab completo.
      exportMultiSheet: 'Export Daily (6 sheets)',
      colStage: 'Stage',
      // C2 — las ocho columnas de los Top-10 de la maqueta.
      colName: "Name",
      colDepto: "Department",
      colOu: "OU",
      colFundamental: "Fundamental",
      colRecos: 'Recognitions',
      colEnviados: "Sent",
      colCrossOu: "Cross-OU",
      colType: "Type",
      crossOu: {
        si: "Yes",
        no: "No",
        desconocido: "—",
      },
      // Las 4 columnas que el Excel comparte con «Brillamos Juntos» (`excelPlantillaTeal.ts`, el
      // mismo constructor arma las hojas de ranking de los dos reportes) y que la pantalla del
      // Diario no pinta.
      colEmail: 'Email',
      colEmployeeId: 'Employee ID',
      colRecognitions: 'Recognitions',
      colDominantType: 'Dominant type',
      // ───────────────────────────────────────────────────────────────────────────
      // Excel de Reconocimiento Diario (`dailyExcel.ts`) — textos EXCLUSIVOS del archivo
      // descargable, calcado de la plantilla del cliente `01 - Reconocimiento Diario.xlsx`
      // (auditoría 2026-09-05). El libro entero sale en el idioma de quien descarga.
      // ───────────────────────────────────────────────────────────────────────────
      excel: {
        sheetSummary: 'Executive Summary',
        sheetDefinitions: 'Definitions',
        sheetFunnel: 'Adoption Funnel',
        sheetTopRecognized: 'Top Recognized',
        sheetTopRecognizers: 'Top Recognizers',
        sheetAllRecognitions: 'All recognitions',
        summaryTitle: 'Daily Recognition — Everyday Fundamentals',
        summarySubtitle: 'Indicators for the selected period: who recognizes, whom they recognize and how often.',
        definitionsTitle: 'What does each figure mean?',
        definitionsSubtitle: 'Plain-language explanation for anyone who downloads this file, with no need for a data background.',
        funnelTitle: 'Adoption Funnel',
        funnelSubtitle: 'Segmentation based on how often recognitions were sent during the funnel month ({{rango}}).',
        funnelEmpty: 'No data: there are no recognitions in the funnel month.',
        topRecognizedTitle: 'Most recognized',
        topRecognizersTitle: 'Top recognizers',
        rankingSubtitle: 'Ranking based on the recognitions of this period.',
        topRecognizersEmpty: 'No data: nobody sent a recognition during the period.',
        allRecognitionsTitle: 'All recognitions',
        allRecognitionsSubtitle: 'Raw day-to-day detail for the period, campaign entries excluded: one row per recognized candidate. Column names keep their original form so the committee pivot tables keep working.',
        allRecognitionsNoRange: 'No data: the exact period range could not be determined, because the aggregate is suppressed by the anonymity threshold and the filter carries no explicit dates.',
        metaPeriod: 'Period',
        metaFilters: 'Applied filters',
        metaFunnelMonth: 'Funnel month',
        metaGenerated: 'Generated',
        colKpi: 'KPI',
        colValue: 'Value',
        colDetail: 'Detail',
        colDatum: 'Figure',
        colWhatIs: 'What it is',
        colHowCalculated: 'How it is calculated',
        colPercentOfTotal: '% of total',
        colSegment: 'Segment',
        colPeople: 'People',
        colAdministrative: 'Office staff',
        colOperational: 'Frontline',
        colFundamental: 'Fundamental',
        colRank: '#',
        colArea: 'Area',
        colSite: 'Site',
        headcountTitle: 'Headcount',
        headcountTotal: 'Total',
        headcountStaff: 'Staff',
        headcountFrontline: 'Frontline',
        headcountPeople: 'People',
        kpiPeers: 'Peers (unique peer-to-peer recognitions)',
        kpiLeaders: 'Leaders (unique recognitions involving a leader)',
        datumTeamRecognitions: 'Recognitions given to teams',
        datumAudienceStaff: 'Staff audience (office)',
        datumAudienceFrontline: 'Frontline audience (operations)',
        datumComparison: 'Previous period and variation',
        datumRankings: 'Top Recognized / Top Recognizers',
        datumLeader: 'Leader',
        datumTruncated: 'All recognitions — truncated',
        whatRecognitionsMade: 'How many recognitions were sent in total during the period, with the applied filters.',
        calcRecognitionsMade: 'Day-to-day recognitions dated within the selected period are added up. Those belonging to a campaign are counted in the We Shine Together report.',
        whatUniqueRecognized: 'How many different people received at least one recognition. Someone who received five counts only once.',
        calcUniqueRecognized: 'The distinct people appearing as recipients during the period are counted.',
        whatTeamRecognitions: 'A recognition is a group one when it has more than one recipient.',
        calcTeamRecognitions: 'The "Recognition type" column of the "All recognitions" sheet marks each row as Individual or Group.',
        whatPeers: 'Recognitions where neither the sender nor the recipient has direct reports: peer to peer, leader to leader, manager to manager.',
        calcPeers: 'Peer-to-peer recognitions within the period are filtered.',
        whatLeaders: 'Recognitions involving at least one person with direct reports.',
        calcLeaders: 'Recognitions where the sender or the recipient is a leader, supervisor or manager are filtered.',
        whatStaffAdoption: 'Of all office people (Staff), the percentage who already recognized someone during the period.',
        calcStaffAdoption: 'Staff people with at least one recognition sent during the period, divided by the total Staff headcount in scope.',
        whatFrontlineAdoption: 'Of all operations or plant people (Frontline), the percentage who already recognized someone during the period.',
        calcFrontlineAdoption: 'Frontline people with at least one recognition sent during the period, divided by the total Frontline headcount in scope.',
        whatTotalUsers: 'How many people in scope have sent at least one recognition ever, since they got an account.',
        calcTotalUsers: 'People with at least one recognition sent throughout their history. It does not depend on the selected period: it comes from the daily census.',
        whatNoActivity: 'People who have never sent a single recognition since they got an account.',
        calcNoActivity: 'Total headcount in scope minus the people with at least one recognition sent throughout their history.',
        whatAudienceStaff: 'People with a corporate Entra ID account.',
        whatAudienceFrontline: 'People who register on the platform with their own email address.',
        whatPrevPeriod: 'Recognitions sent during the same number of days immediately before the selected period.',
        whatVariation: 'How much the recognition volume grew or fell against the equivalent previous period.',
        calcVariation: 'The previous period is the same number of days immediately before the selected one. The variation is the difference between both, divided by the previous period total.',
        whatFunnel: 'Segments the scope by frequency within the funnel month, a window of its own independent from the period above: Regular (four or more a month), Occasional (one to three) and Inactive (none). Each stage is broken down into office staff and frontline.',
        calcFunnel: 'The percentage and the People column are calculated over the headcount in scope. Office staff and frontline count those same people by job type and stay blank when that classification is unavailable.',
        whatRankings: 'The most recognized people and those who recognize the most during the period, up to 200 in each list.',
        calcRankings: 'Sorted by the number of recognitions received or sent. Anyone below the anonymity threshold is masked.',
        whatAllRecognitions: 'Raw detail for the period, one row per candidate: the full Nominee, OnBehalfOf and Candidate blocks, the date, the active Habits matrix and the audit flags. It does not mask people: it is the committee working source, and the anonymity threshold applies to aggregate reports. It includes recognitions from active Brillamos Juntos campaigns, because the Daily report counts them all.',
        calcAllRecognitions: 'Full list of the recognitions in the period, up to a maximum of 5000 rows. Habit columns only include those active in the catalog at export time. The Reco_ID column stays empty because the system does not yet generate a unique identifier per row.',
        whatTruncated: 'This download was cut at the 5000-row cap: the period has more recognitions than the file carries.',
        calcTruncated: 'The cap was reached before every page was walked, so the file is incomplete. Narrow the period and export again.',
        noteLeader: 'A role counts as a leader when it has direct reports.',
        masked: 'Hidden for anonymity',
      },
    },
    shine: {
      title: 'Shine Together',
      subtitle: 'Campaign nomination ranking and live KPIs.',
      recognitionsMade: 'Recognitions given',
      uniqueRecognized: 'Unique people recognized',
      uniqueRecognizers: 'Unique people who recognize',
      participationRate: 'Participation rate',
      totalHeadcount: 'Total headcount',
      // E6 — reemplaza al export de una sola hoja: ahora arma las 7 hojas del Excel de Brillamos.
      exportMultiSheet: 'Export Shine (7 sheets)',
      exporting: 'Exporting…',
      exportError: 'The download could not be completed. Try again.',
      winnersFormat: 'Winners export format',
      formatRaw: 'Raw',
      formatCascaded: 'Cascaded',
      exportWinners: 'Export winners',
      colPos: 'Position',
      kpiTotal: 'Total',
      kpiParticipants: 'Participants',
      kpiParticipation: 'Participation',
      kpiAvgPerPerson: 'Average per person',
      // T-10 — el tab es POR CAMPAÑA (confirmado con Adriana, 18-ago-2026): sin una elegida
      // los indicadores no pueden acotarse y se pide elegir, en vez de pintar los del scope.
      campaignSelector: 'Campaign',
      modalidadSelector: 'Brillamos filter',
      daysLeft: 'Days remaining',
      activeOus: 'Active OUs',
      modalidadTodos: 'All nominees',
      modalidadPersonaUnica: 'Single recipient only',
      modalidadCrossOu: 'Cross-OU',
      pickCampaign: 'Choose a campaign to see its indicators and ranking.',
      habitsRanking: 'Daily Habits ranking',
      colHabit: 'Daily Habit',
      colRecognitions: 'Recognitions',
      colName: 'Name',
      colBu: 'BU',
      colDept: 'Dept.',
      colOrigin: 'Source',
      filterHabitsByFundamental: 'Filter habits by Fundamental',
      allFundamentals: 'All Fundamentals',
      colCount: 'Recognitions',
      colOu: 'OU',
      colCountry: 'Country',
      colBadge: 'Badge',
      colCrossed: 'Cross origin',
      // Tarea 16 — las 6 columnas nuevas de "Top Reconocidos"/"Top Reconocedores" (11 columnas
      // exactas de la plantilla real del cliente). `colCrossOu` reusa la misma
      // traducción que ya usa `reports.daily` para el mismo dato.
      colEmail: 'Email',
      colEmployeeId: 'Employee ID',
      colCrossOu: 'Cross-OU',
      colDominantType: 'Dominant type',
      // Fix round 1 (Tarea 14) — reubicadas desde un bloque `shine` de nivel superior huérfano
      // (nunca se leía: el tab completo usa `reports.shine.*`), que quedaba fuera de `reports` y
      // duplicaba estas mismas 10 claves con el contenido correcto. Sin esto, `tarjetasDeAdopcion`
      // y el banner de filtros aplicados pintaban la clave cruda en vez del texto traducido.
      adoptionStaff: 'Staff users',
      adoptionFrontline: 'Frontline users',
      adoptionTotal: 'Total users',
      noActivity: 'No activity',
      adoptionHint: '{{reconocedores}} of {{plantilla}} have nominated',
      adoptionTotalHint: '{{pct}} of the total headcount ({{plantilla}})',
      noActivityHint: 'Have never sent a nomination',
      appliedFilters: 'Applied filters:',
      appliedFiltersValue: 'Inherited from the panel above · Active campaigns',
      clearAll: 'Clear all',
      // ───────────────────────────────────────────────────────────────────────────
      // Excel de Brillamos Juntos (`brillamosExcel.ts`) — textos EXCLUSIVOS del archivo
      // descargable, calcado de la plantilla del cliente `02 - Campana brillamos juntos.xlsx`
      // (auditoría 2026-09-05): nombres de hoja, banners, metadatos, encabezados de tabla y el
      // glosario completo de «Definiciones». El libro entero sale en el idioma de quien descarga.
      //
      // Las etiquetas de dato que la pantalla ya usa (`recognitionsMade`, `uniqueRecognized`,
      // `adoptionStaff`, `colName`, `colEmail`…) NO se repiten aquí: se reusan de arriba para que
      // la celda del Excel y la columna de la tabla digan lo mismo.
      // ───────────────────────────────────────────────────────────────────────────
      excel: {
        sheetSummary: 'Executive Summary',
        sheetDefinitions: 'Definitions',
        sheetDistribution: 'Fundamental Breakdown',
        sheetFunnel: 'Adoption Funnel',
        sheetTopRecognized: 'Top Recognized',
        sheetTopRecognizers: 'Top Recognizers',
        sheetAllRecognitions: 'All recognitions',
        summaryTitle: 'Shine Together Campaign',
        definitionsTitle: 'What does each figure mean?',
        definitionsSubtitle: 'Plain-language explanation for anyone who downloads this file, no data background required.',
        distributionTitle: 'Breakdown by Fundamental',
        distributionSubtitle: 'Share calculated from this campaign\'s recognitions.',
        distributionChart: 'Recognitions by Fundamental',
        distributionNote: 'A single recognition can carry more than one Fundamental or more than one Habit, and each is counted separately: the totals in this table may not add up to the campaign total or to the count of their Fundamental.',
        distributionEmpty: 'No data: the campaign has no recognitions with a Fundamental recorded in the period.',
        funnelTitle: 'Adoption Funnel',
        funnelSubtitle: 'Segmentation calculated from how often people sent recognitions during the campaign period.',
        funnelEmpty: 'No data: the campaign has no recognitions in the period.',
        topRecognizedTitle: 'Most recognized',
        topRecognizersTitle: 'Top recognizers',
        rankingSubtitle: 'Ranking calculated from this campaign\'s recognitions.',
        topRecognizersEmpty: 'No data: nobody has given recognition within this campaign.',
        allRecognitionsTitle: 'All recognitions',
        allRecognitionsSubtitle: 'Raw campaign detail: one row per recognized candidate. Column names are kept in their original form so the committee\'s pivot tables keep working.',
        metaPeriod: 'Period',
        metaFilters: 'Applied filters',
        metaGenerated: 'Generated',
        colKpi: 'KPI',
        colValue: 'Value',
        colDetail: 'Detail',
        colDatum: 'Figure',
        colWhatIs: 'What it is',
        colHowCalculated: 'How it is calculated',
        colFundamentals: 'Fundamentals',
        colPercentOfTotal: '% of total',
        colSegment: 'Segment',
        colPeople: 'People',
        colAdministrative: 'Staff',
        colOperational: 'Frontline',
        // El Fundamental de una fila del ranking. Clave propia y no la de `reports.daily`:
        // `brillamosExcel.ts` resuelve todo su texto bajo `reports.shine`.
        colFundamental: 'Fundamental',
        colRank: '#',
        colArea: 'Area',
        colSite: 'Site',
        headcountTitle: 'Headcount',
        headcountTotal: 'Total',
        headcountStaff: 'Staff',
        headcountFrontline: 'Frontline',
        headcountPeople: 'People',
        kpiPeers: 'Peers (unique peer-to-peer recognitions)',
        kpiLeaders: 'Leaders (unique recognitions involving a leader)',
        kpiTotalSent: 'Total recognitions sent',
        kpiIndividual: 'Total recognitions to a single person',
        kpiGroup: 'Total recognitions given to groups',
        datumTeamRecognitions: 'Recognitions given to teams',
        datumAudienceStaff: 'Staff audience (office)',
        datumAudienceFrontline: 'Frontline audience (operations)',
        datumLeader: 'Leader',
        datumTruncated: 'All recognitions — truncated',
        whatRecognitionsMade: 'How many recognitions were sent in total within the campaign, under the applied filters.',
        calcRecognitionsMade: 'Every recognition dated within the campaign period is added up.',
        whatUniqueRecognized: 'How many distinct people received at least one recognition. Someone who received five counts once.',
        calcUniqueRecognized: 'The distinct people appearing as recipients in the period are counted.',
        whatTeamRecognitions: 'A recognition is a group one when it has more than one recipient.',
        calcTeamRecognitions: 'Recognitions with two or more people as recipients are counted.',
        whatIndividual: 'Campaign recognitions addressed to a single person.',
        calcIndividual: 'Recognitions with exactly one recipient are counted.',
        whatPeers: 'Recognitions where neither the giver nor the receiver has direct reports: peer to peer, leader to leader, manager to manager.',
        calcPeers: 'Peer-to-peer recognitions within this campaign are filtered out.',
        whatLeaders: 'Recognitions involving at least one person who has direct reports.',
        calcLeaders: 'Recognitions where the giver or the receiver holds a leader, supervisor or manager role are filtered out.',
        whatStaffAdoption: 'Of all office-based people (Staff), the share who have already recognized someone in this campaign.',
        calcStaffAdoption: 'Staff who sent at least one recognition in the campaign, divided by the total Staff in its audience.',
        whatFrontlineAdoption: 'Of all operations or plant people (Frontline), the share who have already recognized someone in this campaign.',
        calcFrontlineAdoption: 'Frontline people who sent at least one recognition in the campaign, divided by the total Frontline in its audience.',
        whatTotalUsers: 'How many people in the campaign audience sent at least one recognition within it.',
        calcTotalUsers: 'People with at least one recognition sent during the campaign period. This is not a lifetime count.',
        whatNoActivity: 'People in the audience who sent no recognition during the campaign.',
        calcNoActivity: 'Campaign audience minus the people with at least one recognition sent in it.',
        whatAudienceStaff: 'People with a corporate Entra ID account.',
        whatAudienceFrontline: 'People who sign up on the platform with their own email address.',
        whatParticipationRate: 'Share of the target audience that took part in the campaign, either giving or receiving recognition.',
        calcParticipationRate: 'Participants divided by the campaign\'s target audience.',
        whatUniqueRecognizers: 'Distinct people who sent at least one recognition within this campaign.',
        calcUniqueRecognizers: 'Count of distinct senders across the campaign\'s recognitions.',
        whatDistribution: 'Two-level hierarchy: each Fundamental with its share of the campaign total and, indented below it, its Daily Habits with the share they represent within that Fundamental.',
        calcDistribution: 'A Fundamental\'s share is its recognition count divided by the campaign total. A Habit\'s share is its recognition count divided by the total of its Fundamental.',
        whatFunnel: 'Segments the campaign audience by frequency: Regulars (four or more per month), Occasional (one to three) and Inactive (none). Each stage is also broken down into Staff and Frontline.',
        calcFunnel: 'The percentage and the People column are calculated over the campaign audience, not over the whole organization. Staff and Frontline count those same people by job type and stay blank when that classification is unavailable.',
        whatAllRecognitions: 'Raw campaign detail, one row per candidate: the full Nominee, OnBehalfOf and Candidate blocks, the date, the matrix of active Habits and the audit flags. It does not mask people: it is the committee\'s working source, and the anonymity threshold applies to aggregated reports.',
        calcAllRecognitions: 'Full list of the period\'s recognitions, up to 5000 rows. Habit columns only include those active in the catalogue at export time. The Reco_ID column is empty because the system does not yet generate a unique identifier per row.',
        whatTruncated: 'This download stopped at the 5000-row cap: the campaign has more recognitions than the file contains.',
        calcTruncated: 'The cap was reached before every page was read, so the file is incomplete. Narrow the period or the campaign and export again.',
        noteLeader: 'A role counts as a leader when it has direct reports.',
        masked: 'Hidden for anonymity',
        crossOuCount: '{{count}} OUs',
      },
    },
    history: {
      title: 'History',
      subtitle: 'Full history of a campaign: name and nominations received.',
      selectCampaign: 'Pick a campaign',
      pickCampaign: 'Pick a campaign to see its history.',
      search: 'Search by name…',
      colPos: 'Position',
      colName: 'Name',
      colNominations: 'Nominations',
      // C2 — «Históricos por Campaña» (rep-panel-historicos).
      colCampaign: "Campaign",
        colType: "Type",
        colStatus: "Status",
      colAudience: 'Audience (people)',
        colRecognitions: "Recognitions",
      colOrigin: "Origin",
        colExpiration: "Expiration",
        colActions: "Actions",
        status: {
        activo: "Active",
          expirado: "Expired",
          borrador: "Draft",
        },
        origin: {
        original: "Original",
          local: "Local",
        },
      // P18-ter — GLOBAL campaigns report (all campaigns, not one), modeled on 03 - Historicos.xlsx.
      kpiTotalCampaigns: 'Total Campaigns',
      kpiTotalRecognitions: 'Total Recognitions',
      kpiAudienceTotal: 'Total Audience',
      kpiParticipantsTotal: 'Participants',
      kpiParticipantsStaff: 'Staff Participants',
      kpiParticipantsFrontline: 'Frontline Participants',
      kpiParticipationRate: 'Participation Rate',
      kpiAvgPerParticipant: 'Average recognitions per participant',
      colDescription: 'Description',
      colParticipants: 'Participants',
      colParticipantsStaff: 'Staff Participants',
      colParticipantsFrontline: 'Frontline Participants',
      colDuration: 'Campaign duration',
      colFrequency: 'Frequency',
      colGoalPercent: '% of Goal',
      downloadGlobalExcel: 'Download global report',
      downloadGlobalError: 'The global report could not be downloaded.',
      // Históricos Excel (`historicosExcel.ts`) — text that belongs ONLY to the downloadable file:
      // sheet names, banner, metadata and glossary. Data labels are not repeated here: the `kpi*`/
      // `col*` keys above are reused so the Excel column and the on-screen column say the same.
      excel: {
        sheetSummary: 'Executive Summary',
        sheetDefinitions: 'Definitions',
        sheetCampaigns: 'Historical Campaigns',
        summaryTitle: 'Campaign History',
        summarySubtitle: 'Consolidates the recognition campaign history: audience, participation and recognition volume for each one.',
        campaignsSubtitle: 'Side-by-side detail for every campaign.',
        definitionsTitle: 'What does each figure mean?',
        definitionsSubtitle: 'Plain-language explanation, aligned with the Executive Summary and including how each KPI is measured.',
        metaFilter: 'Filter applied',
        metaGenerated: 'Generated',
        filterAllCampaigns: 'All campaigns',
        colKpi: 'KPI',
        colValue: 'Value',
        colNote: 'Note / definition',
        colDatum: 'Figure',
        colWhatIs: 'What it is',
        colHowMeasured: 'How it is measured',
        colHowCalculated: 'How it is calculated',
        colComparedTo: 'Compared against',
        colWhereShown: 'Where it appears',
        colAudienceOu: 'Audience OU',
        whereSummary: 'Executive Summary',
        whereSummaryCampaigns: 'Executive Summary / Historical Campaigns',
        datumStaffFrontline: 'Staff Participants / Frontline Participants',
        durationMonths_one: '{{count}} month',
        durationMonths_few: '{{count}} months',
        durationMonths_other: '{{count}} months',
        whatCampaigns: 'How many campaigns the history or the applied filter includes.',
        measuredCampaigns: 'Measured by counting every campaign registered with a valid name in the history.',
        calcCampaigns: 'Count of unique campaigns within the scope of the report.',
        vsCampaigns: 'Against the universe of available campaigns or against earlier cut-offs.',
        whatRecognitions: 'Recognitions accumulated within the selected scope.',
        measuredRecognitions: 'Measured as every recognition registered for the campaigns included.',
        calcRecognitions: 'Sum of all recognitions across the filtered campaigns.',
        vsRecognitions: 'Against other campaigns, earlier periods or the defined goal.',
        whatAudience: 'Number of employees the campaign was aimed at.',
        measuredAudience: 'Measured with the target audience defined in the campaign settings.',
        calcAudience: 'Total eligible employees within the OU, country, BU or configured scope.',
        vsAudience: 'The basis for participation; 100% means the whole audience was covered.',
        whatParticipants: 'Distinct people who took part by sending at least one recognition.',
        measuredParticipants: 'Measured by counting unique people who sent at least one recognition.',
        calcParticipants: 'Distinct count of senders with one or more recognitions.',
        vsParticipants: 'Against Total Audience and against comparable campaigns.',
        whatStaffFrontline: 'Of the participants, how many are office-based (Staff) and how many are plant personnel (Frontline).',
        measuredStaffFrontline: "Each person's current segment is resolved when the report runs, not the one they had when they took part.",
        calcStaffFrontline: 'Count of participants by the segment recorded in their directory profile.',
        vsStaffFrontline: 'Against the total Participants on that same row.',
        whatRate: 'Share of the target audience that did take part.',
        measuredRate: 'Measured as the proportion of participants over the total audience.',
        calcRate: 'Participants / Total Audience.',
        vsRate: 'Against the participation goal; 100% means the whole audience took part.',
        whatAvg: 'Average recognitions generated by each active participant.',
        measuredAvg: 'Measured across the people who sent at least one recognition.',
        calcAvg: 'Total Recognitions / Participants.',
        vsAvg: 'Against other campaigns or against the expected average per participant.',
      },
    },
    headcount: {
      notaPeriodo: 'Reference for the period: the KPIs above are calculated over this headcount.',
      notaAdopcion: 'This is the denominator of adoption: of this headcount, how many people have nominated.',
      title: 'Headcount',
      updatedOn: 'Headcount updated: {{fecha}}',
      updatedOnTitle: 'Headcount updated',
      sourceLatam: 'LATAM: {{fecha}}',
      sourceEuropa: 'Europe: {{fecha}}',
      sourceUsa: 'USA: {{fecha}}',
      sinDato: 'No data',
      hint: 'Last load of users registered on the platform',
      total: 'Total people',
      staff: 'Staff',
      frontline: 'Frontline',
    },
    heatmap: {
      title: 'Heatmap OU × Fundamental',
      subtitle: 'Recognitions volume by OU and Fundamental. Color intensity shows the relative concentration within each column.',
      ou: 'Org unit',
      // C2 — la columna Total que la maqueta cierra en el mapa de calor.
      total: 'Total',
    },
    network: {
      title: 'ONA Network',
      subtitle: 'Recognition flow across units (cross collaboration).',
      ous: 'Units',
      flows: 'Flows',
      legendCross: 'Cross-OU flow',
      legendInternal: 'Internal flow',
      legendNode: 'Unit (size = volume)',
      // C2 — la tabla de flujos que pide la maqueta, en vez del grafo SVG.
      colFlow: 'Flow (From → To)',
      colRecognitions: 'Recognitions',
      // C2/C4 (2026-08-13) — reemplaza a `colIntensity`: la spec descartó el % de Intensidad y lo
      // sustituyó por el Fundamental más reconocido de la relación (`OnaEdgeDto.fundamentalDominante`).
      colDominantFundamental: 'Recognition volume',
      colDominantFundamentalHelp: 'The bar\'s length represents the flow\'s recognition volume; its color shows which Fundamental was the most recognized within it.',
    },
    // 2026-09-04 — hoja "Definiciones" del Excel Demográfico, calcada de la plantilla del cliente
    // (`04 - Demografico.xlsx`): banner, las 4 columnas del glosario y una definición por cada dato
    // que el archivo realmente trae. Vivían como literales en español dentro de
    // `DemograficoExportButton.tsx`, así que la hoja salía en español aunque el resto del libro
    // fuera en el idioma de quien descarga.
    definitions: {
      title: 'What does each figure mean?',
      subtitle: 'Plain-language explanation for anyone who downloads this file, no data background required.',
      colData: 'Figure',
      colWhat: 'What it is',
      colHow: 'How it is calculated',
      colVs: 'Compared against',
      percentTotalWhat: 'What share of the whole active workforce belongs to each generation.',
      percentTotalHow: 'Active people in that generation, across every OU in scope, divided by the total active workforce with a known generational band.',
      percentTotalVs: 'The other generations in the same table.',
      gapWhat: 'How strongly a generation lives each Fundamental, on a 1 to 4 scale, and how far its lowest Fundamental sits from its highest.',
      gapHow: 'Average Pulso score by generation and Fundamental; the Δ is the row maximum minus the row minimum, to one decimal.',
      gapVs: 'The other Fundamentals of the same generation.',
      heatmapWhat: 'How many recognitions were given in each organisational unit, broken down by Fundamental.',
      heatmapHow: 'Count grouped by OU and Fundamental; cells with fewer than 5 recognitions are hidden for anonymity.',
      heatmapVs: 'The other OUs and Fundamentals in the same table.',
      networkWhat: 'How many recognitions flowed from one organisational unit to another.',
      networkHow: 'Count of recognitions sent from one OU to another, sorted from highest to lowest.',
      networkVs: 'The other flows in the same table.',
    },
    generational: {
      title: 'Generational Distribution',
      subtitle: 'Recognitions grouped by generational band.',
      filterBu: 'Filter by BU…',
      filterDepto: 'Filter by department…',
      filterSite: 'Filter by site…',
      roleAll: 'All',
      roleLeaders: 'Leaders',
      rolePeers: 'Peers',
      // Bug UAT (17-ago-2026) — estas cuatro claves vivían por error en `admin.moderation`, así
      // que `BrechaGeneracionalTable` pintaba la clave cruda («reports.generational.gapTitle»).
      // Su sitio es este bloque: las consume el tab Demográfico, no la bandeja de moderación.
      gapTitle: 'Generational Gap × Fundamental',
      gapSubtitle: 'Average score (1–4) by generation and Fundamental. Δ Gap ≥ 1.0 = critical.',
      gapTitleHelp: 'Each cell is rounded to 1 decimal for display. The Δ Gap is calculated on the full (unrounded) value of the row\'s maximum minus minimum, so it may not match the visual subtraction of the rounded columns.',
      colGeneration: 'Generation',
      colGap: 'Δ Gap',
      // C5/C7 (2026-08-13) — marcado visual de `ousConCobertura`: qué unidades tuvieron cobertura
      // de fecha de nacimiento suficiente para aportar al cálculo generacional.
      // T-11 — tarjetas de la maqueta: conteo de personas por banda y marca de la mayoritaria.
      people_one: '{{count}} person',
      people_other: '{{count}} people',
      majority: 'majority',
      coverageTitle: 'Units with generational data coverage',
      // C7 — botón de export consolidado (6 hojas) del panel Demográfico completo.
      exportConsolidated: 'Export Demographic panel (5 sheets)',
      // Task 9 — column labels for the generational distribution export sheet.
      // 2026-09-03 — encabezado de la hoja "Resumen Ejecutivo" del Excel Demográfico
      // (subtítulo + bloque de metadatos), según la plantilla de referencia del cliente.
      exportSubtitle: 'Workforce composition by generation, OU and employee type',
      metaPeriod: 'Period',
      metaFilters: 'Filters applied',
      metaGenerated: 'Generated',
      colPercentTotal: '% of total',
      colYearRange: 'Year range',
      colPeople: 'People',
      colFrontline: 'Frontline',
      colStaff: 'Staff',
      colNote: 'Note',
      // Valores de la columna «Nota» del Resumen Ejecutivo. Los emite
      // `buildGenerationalDistributionMatrix` como identificador canónico, no como texto,
      // justamente para poder traducirlos aquí.
      noteMajority: 'Majority',
      noteSmallSample: 'Small sample',
    },
    leaders: {
      title: 'Leaders',
      subtitle: 'Direct team size and recognitions per leader.',
      export: 'Export to Excel',
      colLeader: 'Leader',
      colPosition: 'Position',
      colOu: 'OU',
      colLevel: 'Level',
      colTeamSize: 'Team size',
      colTeamReceived: 'Team recognitions (received)',
      colTeamReceivedHelp: 'Total recognitions received by people within the leaders’ structures.',
      colTeamSent: 'Team recognitions (sent)',
      colTeamSentHelp: 'Total recognitions sent by people within the leaders’ structures.',
      colLeaderSent: 'Recognitions sent by the leader',
      colLeaderReceived: 'Recognitions received by the leader',
      colParticipation: 'Participation',
      colRatio: 'Ratio',
      colExport: 'Export',
      exportRow: 'Export this row',
      exportRowFor: 'Export the row for {{name}}',
      kpiTotalLeaders: 'Total leaders',
      kpiTeamSizeSum: 'Total team size',
      kpiRatioAvg: 'Average ratio',
      kpiParticipationAvg: 'Average participation',
      emptyByPerson: 'The selected person does not appear in any team within your scope. Remove the person filter to see the full table.',
      // Textos del Excel de Líderes (`leadersExcel.ts`): nombres de hoja, banner, bloque de
      // metadatos, encabezados de las hojas Resumen/Definiciones, el «Detalle» de cada KPI y el
      // glosario completo. Las etiquetas de dato NO se repiten aquí: se reusan de `col*`/`kpi*`
      // de arriba, que son las mismas que ya se leen en pantalla.
      excel: {
        sheetSummary: 'Executive Summary',
        sheetDefinitions: 'Definitions',
        sheetTeams: 'Teams by leader',
        teamsSubtitle: 'Recognition detail by reporting structure.',
        definitionsTitle: 'What does each figure mean?',
        definitionsSubtitle: 'Plain-language explanation for anyone who downloads this file — no data background required.',
        metaPeriod: 'Period',
        metaFilters: 'Applied filters',
        metaGenerated: 'Generated',
        colKpi: 'KPI',
        colValue: 'Value',
        colDetail: 'Detail',
        colDatum: 'Figure',
        colWhatIs: 'What it is',
        colHowCalculated: 'How it is calculated',
        detailTotalLeaders: 'People with at least one direct report within the scope queried.',
        detailTeamSize: 'Sum of the direct reports of every leader in the list.',
        detailTeamReceived: 'Recognitions received by the people who make up those teams.',
        detailTeamSent: 'Recognitions sent by the people who make up those teams.',
        detailLeaderReceived: 'Recognitions received by the leaders themselves, excluding their team.',
        detailLeaderSent: 'Recognitions sent by the leaders themselves, excluding their team.',
        detailRatio: 'Team recognitions received divided by those sent.',
        detailParticipation: 'Average participation across the leaders’ teams.',
        whatTeamSize: 'How many people report directly to that leader.',
        howTeamSize: 'Count of people whose manager is the leader. It does not cascade down the lower levels of the org chart.',
        whatTeamReceived: 'How many recognitions the people on that leader’s team received in total, from anyone.',
        howTeamReceived: 'Sum of recognitions where the receiver belongs to the leader’s direct team.',
        whatTeamSent: 'How many recognitions the people on that leader’s team sent in total, to anyone.',
        howTeamSent: 'Sum of recognitions where the sender belongs to the leader’s direct team.',
        whatLeaderReceived: 'How many recognitions the leader received in total, from anyone.',
        howLeaderReceived: 'Count of recognitions where the receiver is the leader. It does not include their team.',
        whatLeaderSent: 'How many recognitions the leader sent, to anyone.',
        howLeaderSent: 'Count of recognitions where the sender is the leader. It does not include their team.',
        whatRatio: 'How much more recognition a team receives compared with what it gives to others.',
        howRatio: 'Team recognitions received divided by those sent. “—” if the team sent none.',
        whatParticipation: 'What percentage of that leader’s team has recognised someone at least once.',
        howParticipation: 'People on the team with at least 1 recognition sent, divided by the team size. Receiving does not count: it is someone else’s action.',
        whatLeader: 'An employee with people reporting to them in the company headcount.',
        howLeader: 'Anyone with at least one direct report. The summary adds up the leaders of every geography in the scope queried.',
        whatLevel: 'The leader’s depth in the org chart: N-1 is the root (no manager), then N-2, N-3… downwards.',
        howLevel: 'Chain of managers up to the root + 1, calculated across the whole company and not only among the leaders visible in this list.',
      },
    },
    moderation: {
      title: 'Moderation',
      subtitle: 'Detail of reported recognitions. Includes contact data for escalation.',
      total: 'Total reports',
      pending: 'Pending',
      hidden: 'Hidden',
      restored: 'Restored',
      colReported: 'Reported',
      colReportedEmail: 'Reported email',
      colOu: 'OU',
      colCountry: 'Country',
      colReporter: 'Reporter',
      colReporterEmail: 'Reporter email',
      colReason: 'Reason',
      colStatus: 'Status',
      colDate: 'Date',
      statusPending: 'Pending',
      statusHidden: 'Hidden',
      statusRestored: 'Restored',
      statusPublished: 'Published',
      colComment: 'Reported comment',
      colLanguage: 'Language',
      colReportCount: '# Reports',
      export: 'Export to Excel',
    },
    campaigns: {
      title: 'Campaign history',
      subtitle: 'All campaigns (active and expired): audience and recognitions.',
      search: 'Search by name…',
      // D4 — category selector (Fundamentales/Brillamos/Personalizada) that replaced the combined
      // table export.
      filterTypeLabel: 'Category',
      filterAllTypes: 'All categories',
      summaryParticipants: 'Total participants',
      summaryRate: 'Participation %',
      colName: 'Name',
      colType: 'Type',
      colStatus: 'Status',
      colAudience: 'Audience (people)',
      colRecognitions: 'Recognitions',
      // C2 — «Participation by Campaign» (rep-panel-campgeneral).
      colParticipants: 'Participants',
      colRate: 'Participation rate',
      colAvgUser: 'Average per participant',
      colAvgUserHelp: 'Average recognitions generated by each campaign participant: recognitions ÷ participants.',
      dominantFundamentalTooltip: 'Most recognized Fundamental: {{name}}',
      colExpiration: 'Expiration date',
      colActions: 'Actions',
      prevPage: 'Previous',
      nextPage: 'Next',
      pageOf: 'Page {{page}} of {{total}}',
      type: {
        Fundamentales: 'Fundamentals',
        Brillamos: 'Shine Together',
        Personalizada: 'Custom',
      },
      status: {
        activo: 'Active',
        finalizada: 'Expired',
        borrador: 'Draft',
      },
      // D3 — Reportería deja de ofrecer pausar/relanzar/enviar-a-aprobación (esa máquina de estados
      // vive en el editor de campañas, `admin.campaigns`). Queda una sola acción por fila: descargar
      // el Excel de esa campaña.
      downloadExcel: 'Download Excel',
      // D6 — user-facing error when the per-campaign export fails (network/backend), shown via Toast.
      downloadError: "Could not download the campaign's Excel file.",
    },
  },
  // ── D5 Pass-C — Preferences, team, dashboard, leaderboard, custom campaign ──
  notifPrefs: {
    title: 'Notifications',
    subtitle: 'Choose which alerts you receive by email.',
    unavailable: 'Your preferences could not be loaded.',
    emailEnabled: 'Receive emails',
    emailHint: 'Master switch for all emails.',
    saveError: 'Your preferences could not be saved.',
    cat: {
      recognitionReceived: 'Recognitions received',
      streakAndBadges: 'Streaks & badges',
      campaigns: 'Campaigns',
      digest: 'Activity digest',
    },
    catHint: {
      recognitionReceived: 'When someone recognizes you.',
      streakAndBadges: 'Your streak and unlocked badges.',
      campaigns: 'Shine campaign updates.',
      digest: 'Periodic summary of your activity.',
    },
    catLockedAntiSpoiler: 'Locked while Anti-Spoiler Mode is active: we can\'t notify you about your recognitions until the campaign ends.',
  },
  team: {
    mostRecognized: 'Most Recognized', mostRecognizers: 'Top Recognizers',
    title: 'My team',
    subtitle: "Your team's recognition participation.",
    subtitleFor: "{{name}}'s team",
    empty: 'No team activity yet.',
    teamSize: 'Team size',
    sent: 'Sent',
    received: 'Received',
    participation: 'Participation',
    members: 'Team members',
    emptyMembers: 'No members to show.',
    colMember: 'Member',
    colSent: 'Sent',
    colReceived: 'Received',
    colStreak: 'Streak',
    noStreak: 'No streak',
    explore: 'Explore their team',
    myTeam: 'My team',
    breadcrumb: 'Team path',
    colTopFundamental: 'Top Fundamental',
    // La celda lleva las DOS lecturas etiquetadas: por lo que RECONOCEN a la persona (el dato
    // que existe para todo el equipo) y lo que ella usa al reconocer (UAT 18-ago-2026).
    fundRecibido: 'Recognized for:',
    fundEnviado: 'Recognizes for:',
    colActions: 'Actions',
    viewButton: "View {{name}}'s profile",
    viewButton_short: 'View',
    backToTeam: 'Back to team',
    backToProfile: 'Back to my profile',
    expandMember: "View {{name}}'s details",
  },
  tablero: {
    title: 'Executive dashboard',
    subtitle: 'Recognition Program KPIs. Never shows points.',
    empty: 'No KPIs for the selected scope.',
    // RF-143 (C4) — drill-down por Fundamental y por generación.
    allFundamentals: 'All Fundamentals',
    allGenerations: 'All generations',
    notApplicableNote: 'With the generation filter on, KPIs computed over total headcount show as “n/a”: the census is not broken down by generation, so that percentage would mean something else.',
    // 🔴 Las CLAVES son los valores exactos de GenerationHelper (UserAdminService); solo se
    //    traduce el rótulo. Cambiar una clave dejaría el filtro sin casar con nadie.
    generations: {
      GenAlpha: 'Gen Alpha',
      GenZ: 'Gen Z',
      Millennial: 'Millennials',
      GenX: 'Gen X',
      BabyBoomer: 'Baby Boomers',
      Silent: 'Silent Generation',
    },
  },
  leaderboard: {
    title: 'OU leaderboard',
    subtitle: 'Nominations by org unit/country.',
    noOu: 'No OU',
    you: ' (you)',
  },
  campaignType: {
    personalizada: 'Custom campaign',
  },
  campaignLanding: {
    customNote: 'This is an informational campaign. Explore its documents and microsite.',
  },
  innovacion: {
    kpiStreak: 'Streak',
    kpiStreakHint: 'record: {{record}} weeks',
    kpiStreakHintMonthly: 'record: {{record}} months',
    kpiNominationsHint2: '{{count}} different people',
    fundamentalsTitle: 'Fundamentals of this campaign',
    nominateSecondary: 'Go to the Nominate page',
    kpiNominations: 'Nominations',
    kpiNominationsHint: 'Sent in this campaign',
    kpiUnique: 'People nominated',
    kpiUniqueHint: 'Unique recipients',
    kpiDaysLeft: 'Days left',
    suppressed: 'Data is suppressed for privacy: the group is too small to display figures.',
    kpisUnavailable: 'Live KPIs are unavailable right now.',
    recentTitle: 'Recent recognitions',
    recentEmpty: 'No recognitions in this campaign yet.',
    noCampaign: 'There is no active custom campaign. One can be created from Administration → Campaigns.',
  },
};

export default recognition;
